//Funciones comunes del proceso de configuración inicial
const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const putAccountIDInstallation = endpointHelias+'/Helias/V0/Configuration/putAccountIDInstallation'
const putInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/putInstallationConfiguration"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const putInstallationMonitoring = endpointHelias+"/Helias/V0/Monitor/putInstallationMonitoring"
const postInitialConfigDevicesList = endpointHelias+"/Helias/V0/Configuration/postInitialConfigDevicesList"
const getHelias3pCredentials = endpointHelias+"/3rdParty/V0/Credentials/getHelias3pCredentials"
const deleteHelias3pCredentials = endpointHelias+"/3rdParty/V0/Credentials/deleteHelias3pCredentials"
const userAccountFullDeletion = endpointHelias+"/Helias/V0/Configuration/userAccountFullDeletion"
const postInstallationMaximunConsumptionReset = endpointHelias+"/Helias/V0/Configuration/postInstallationMaximunConsumptionReset"
const deleteAccountIDInstallation = endpointHelias+"/Helias/V0/Configuration/deleteAccountIDInstallation"
const deleteAccountIDInstaller = endpointHelias+"/Helias/V0/Configuration/deleteAccountIDInstaller"

var generalCommonJS = require("../js/generalCommon.js")

var camposSensores = ["acometidaPrincipal1","acometidaPrincipal2","acometidaPrincipal3","sensorFV","sensorBaterias","sensorFase1","sensorFase2","sensorFase3"]
var camposDispositivos = ["automaticoPrincipal","sensorTemperaturaBaterias","sensorOnOff"]
var camposCoches = ["car"]

var aplicacionesValidasSensores = ["VICTRON", "EFERGY", "SHELLY", "FUSIONSOLAR","SOLARWEB","KOSTAL","KOSTAL_LOCAL","IBERDROLA_SMART_MONITOR", "SMARTLIFE", "TUYA", "ENERGEEKS_30", "SOLARMAN", "EDP_SOLAR", "ESAJ_HOME","TESLA"]
var aplicacionesValidasDispositivos = ["EWELINK", "SMARTLIFE", "TPLINK", "TUYA", "TAPO", "ARISTON","BRONPI","ECOFORESTCONTROL","BROADLINK","HOME_ASSISTANT","SHELLY", "ENERGEEKS_30","IAQUALINK","MELCLOUD","COMFORT_CLOUD","MEROSS","ONECTA_DAIKIN","GOVEE","XIAOMI","SMARTTHINGS"]
var aplicacionesValidasCoches = ["TESLA"]

exports.obtenerCamposSensores = function(){
  return camposSensores
}

exports.obtenerCamposDispositivos = function(){
  return camposDispositivos
}

exports.obtenerCamposCoches = function(){
  return camposCoches
}

exports.mostrarAplicacionesValidas = function(campoActual,idListado){

  if(document.getElementById(idListado) !== null){

    var objListadoAplicaciones = document.getElementById(idListado).querySelectorAll("li")
    var tipoCampo = ""
    var icono = ""

    var prefijoListado = ""

    if(idListado === "listadoAplicacionesConfiguradasParaEstePaso"){
      prefijoListado = "CONF-"
    }
    else if(idListado === "listadoAppsDispositivosInteligentes"){
      prefijoListado = "DEV-"
    }

    var hayAplicacionesCompatibles = false

    //Identifico el tipo de campo
    if(camposSensores.includes(campoActual)){ 
        tipoCampo = "Sensor" 
        icono = "sensors"
    }
    else if(camposDispositivos.includes(campoActual) || campoActual === ""){ 
        tipoCampo = "Dispositivo" 
        icono = "devices_other"
    }
    else if(camposCoches.includes(campoActual)){ 
        tipoCampo = "Coche" 
        icono = "directions_car"
    }
    else{//Sino establezco por defecto dispositivo
        tipoCampo = "Dispositivo"
        icono = "cable"
    }

    document.getElementById("headerVincular").innerHTML = "Registrar aplicación"
    document.getElementById("spanIconVincular").innerHTML = icono
    
    //Actualizo la visibilidad en función del mismo
    for(var x=0; x < objListadoAplicaciones.length; x++){

      if(tipoCampo === "Sensor"){ 
        if(aplicacionesValidasSensores.includes(objListadoAplicaciones[x].id.replaceAll(prefijoListado, ""))){
          document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "")
          hayAplicacionesCompatibles = true
        }
        else{
          document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "") + " hidden"
        }
      }
      else if(tipoCampo === "Dispositivo"){ 
        if(aplicacionesValidasDispositivos.includes(objListadoAplicaciones[x].id.replaceAll(prefijoListado, ""))){
          document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "")
          hayAplicacionesCompatibles = true        
        }
        else{
          document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "") + " hidden"
        }
      }
      else if(tipoCampo === "Coche"){
        if(aplicacionesValidasCoches.includes(objListadoAplicaciones[x].id.replaceAll(prefijoListado, ""))){              
            document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "")
            hayAplicacionesCompatibles = true
        }
        else{
            document.getElementById(objListadoAplicaciones[x].id).className = document.getElementById(objListadoAplicaciones[x].id).className.replaceAll(" hidden", "") + " hidden"          
        }

      }
      //Sino no hago nada y muestro todas
    }

    if(idListado === "listadoAplicacionesConfiguradasParaEstePaso"){
      if(hayAplicacionesCompatibles){
        document.getElementById("mensajeSinAplicacionesCompatibles").className = document.getElementById("mensajeSinAplicacionesCompatibles").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.getElementById("mensajeSinAplicacionesCompatibles").className = document.getElementById("mensajeSinAplicacionesCompatibles").className.replaceAll(" hidden", "")
      }
    }

  }  

}

exports.obtenerLiteralAtributo = function(atributo){
			
  var literalAtributo = "";
  
  if(atributo === "InstallationName"){ literalAtributo = "Nombre de la instalación"; }
  else if(atributo ===  "DashboardTimerRefresh"){ literalAtributo = "Tiempo de refresco del dashboard"; }
  else if(atributo ===  "FVInstallationConfigured"){ literalAtributo = "Fotovoltaica configurada"; }
  else if(atributo ===  "BatteriesInstallationConfigured"){ literalAtributo = "Baterías configuradas"; }
  else if(atributo ===  "GeneratorInstallationConfigured"){ literalAtributo = "Grupo electrógeno configurado"; }
  else if(atributo ===  "TotalMaximunGeneration"){ literalAtributo = "Potencia máxima total"; }
  else if(atributo ===  "TotalBulkGeneration"){ literalAtributo = "Energía generada"; }
  else if(atributo ===  "TotalBulkConsumption"){ literalAtributo = "Energía consumida"; }
  else if(atributo ===  "TotalReactiveEnergy"){ literalAtributo = "Energía reactiva"; }  
  else if(atributo ===  "TotalCapacitiveEnergy"){ literalAtributo = "Energía capacitiva"; }  
  else if(atributo ===  "TotalWastedEnergy"){ literalAtributo = "Energía devuelta / perdida"; }
  else if(atributo ===  "CarsInInstallation"){ literalAtributo = "Existen coches en la instalación"; }
  else if(atributo ===  "EnergyBuyPrice"){ literalAtributo = "Precio compra KWh"; }
  else if(atributo ===  "BestBuyPrice"){ literalAtributo = "Ahora es el mejor precio de compra del día"; }
  else if(atributo ===  "BestSellPrice"){ literalAtributo = "Ahora es el mejor precio de venta del día"; }
  else if(atributo ===  "WorstBuyPrice"){ literalAtributo = "Ahora es el peor precio de compra del día"; }
  else if(atributo ===  "WorstSellPrice"){ literalAtributo = "Ahora es el peor precio de venta del día"; }
  else if(atributo ===  "Sunrise"){ literalAtributo = "Hora salida del sol"; }
  else if(atributo ===  "Sunset"){ literalAtributo = "Hora puesta del sol"; }

  else if(atributo ===  "ItsDay"){ literalAtributo = "Es de día"; }
  else if(atributo ===  "ItsNight"){ literalAtributo = "Es de noche"; }
  else if(atributo ===  "SunriseOffset"){ literalAtributo = "Al amanecer"; }
  else if(atributo ===  "SunsetOffset"){ literalAtributo = "Al anochecer"; }

  else if(atributo ===  "Timeframe"){ literalAtributo = "Franja horaria"; }
  else if(atributo ===  "SkyStatus"){ literalAtributo = "Estado del cielo"; }
  else if(atributo ===  "SkyStatusValue"){ literalAtributo = "Valor estado del cielo"; } //Este se irá fuera, es la imagen
  else if(atributo ===  "Temperature"){ literalAtributo = "Temperatura exterior"; }
  else if(atributo ===  "UV"){ literalAtributo = "Factor UV"; }
  else if(atributo ===  "SolarRadiation"){ literalAtributo = "Radiación solar"; }
  else if(atributo ===  "FVInstallationDetected"){ literalAtributo = "Instalación fotovoltaica detectada"; }
  else if(atributo ===  "FVMaxGeneration"){ literalAtributo = "Generación máxima teórica"; }
  else if(atributo ===  "FVPerformance"){ literalAtributo = "Rendimiento"; }
  else if(atributo ===  "GeneralWhFVGeneration"){ literalAtributo = "Generación"; }  
  else if(atributo ===  "BatteriesInstallationDetected"){ literalAtributo = "Baterías detectadas en la instalación"; }
  else if(atributo ===  "IC1Status"){ literalAtributo = "Estado del inversor"; }
  else if(atributo ===  "BatteriesInverterMaxPower"){ literalAtributo = "Potencia máxima"; }
  else if(atributo ===  "GeneralBatteryPercentage"){ literalAtributo = "% Batería"; }
  else if(atributo ===  "BatteryVoltage"){ literalAtributo = "Voltaje"; }
  else if(atributo ===  "BatteryAmperage"){ literalAtributo = "Amperaje"; }
  else if(atributo ===  "CurrentBatteryWorkingMode"){ literalAtributo = "Modo TOU"; }  
  else if(atributo ===  "BatteryTemperature"){ literalAtributo = "Temperatura"; }
  else if(atributo ===  "BatteryStatus"){ literalAtributo = "Estado"; }
  else if(atributo ===  "RemainingBatteryDischargeTime"){ literalAtributo = "Tiempo restante para descarga completa"; }
  else if(atributo ===  "RemainingBatteryChargeTime"){ literalAtributo = "Tiempo restante para carga al 100%"; }
  else if(atributo ===  "BatteryWhConsumption"){ literalAtributo = "Consumo"; }
  else if(atributo ===  "GeneratorInstallationDetected"){ literalAtributo = "Grupo detectado en instalación"; }
  else if(atributo ===  "GeneratorOnOffSwitch"){ literalAtributo = "Interruptor encendido/apagado grupo"; }
  else if(atributo ===  "GeneratorMaxGeneration"){ literalAtributo = "Generación máxima"; }
  else if(atributo ===  "GeneratorPerformance"){ literalAtributo = "Rendimiento"; }
  else if(atributo ===  "CombustiblePrice"){ literalAtributo = "Precio del combustible"; }
  else if(atributo ===  "GeneratorTankCapacity"){ literalAtributo = "Capacidad del depósito"; }
  else if(atributo ===  "CurrentGeneratorTankLevel"){ literalAtributo = "Nivel del depósito"; }
  else if(atributo ===  "CurrentGeneratorTankPercentage"){ literalAtributo = "% del depósito"; }
  else if(atributo ===  "CurrentGeneratorLitersConsumption"){ literalAtributo = "Consumo de combustible L/Hr"; }
  else if(atributo ===  "CurrentGeneratorConsumptionCost"){ literalAtributo = "Consumo de combustible €/Hr"; }
  else if(atributo ===  "GeneralWhGeneratorTOTALGeneration"){ literalAtributo = "Generación total"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP1"){ literalAtributo = "Generación de la Fase 1"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP2"){ literalAtributo = "Generación de la Fase 2"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP3"){ literalAtributo = "Generación de la Fase 3"; }
  else if(atributo ===  "GeneralWhInstallationTOTALConsumption"){ literalAtributo = "Consumo"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP1"){ literalAtributo = "Consumo - Fase 1"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP2"){ literalAtributo = "Consumo - Fase 2"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP3"){ literalAtributo = "Consumo - Fase 3"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP1"){ literalAtributo = "Devuelto a la red - Fase 1"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP2"){ literalAtributo = "Devuelto a la red - Fase 2"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP3"){ literalAtributo = "Devuelto a la red - Fase 3"; }			
  else if(atributo ===  "GeneralWhInstallationTOTALReactiveEnergy"){ literalAtributo = "Energía reactiva"; }  
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP1"){ literalAtributo = "Energía reactiva - Fase 1"; }
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP2"){ literalAtributo = "Energía reactiva - Fase 2"; }
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP3"){ literalAtributo = "Energía reactiva - Fase 3"; }
  else if(atributo ===  "GeneralWhInstallationTOTALCapacitiveEnergy"){ literalAtributo = "Energía capacitiva"; }  
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP1"){ literalAtributo = "Energía capacitiva - Fase 1"; }
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP2"){ literalAtributo = "Energía capacitiva - Fase 2"; }
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP3"){ literalAtributo = "Energía capacitiva - Fase 3"; }
  else if(atributo ===  "CarName"){ literalAtributo = "Nombre"; }
  else if(atributo ===  "ChargeLevel"){ literalAtributo = "Nivel de carga"; }
  else if(atributo ===  "Autonomy"){ literalAtributo = "Autonomía en Kms"; }
  else if(atributo ===  "ChargeStatus"){ literalAtributo = "Estado de carga"; }
  else if(atributo ===  "ChargePower"){ literalAtributo = "Potencia de carga"; }
  else if(atributo ===  "RemainingChargeTime"){ literalAtributo = "Tiempo restante de carga"; }
  else if(atributo ===  "ChargeVoltage"){ literalAtributo = "Voltaje de carga"; }
  else if(atributo ===  "ChargeAmperage"){ literalAtributo = "Amperaje de carga"; }
  else if(atributo ===  "CurrentChargeLimit"){ literalAtributo = "Límite de carga"; }
  else if(atributo ===  "ChargeType"){ literalAtributo = "Tipo de carga"; }
  else if(atributo ===  "FVMaxGenerationEstimation"){ literalAtributo = "Estimación generación máxima"; }
  else if(atributo ===  "FVMaxGenerationEstimationConnected"){ literalAtributo = "Generación"; }
  else if(atributo ===  "FVWastedEnergy"){ literalAtributo = "Energia perdida"; }
  else if(atributo ===  "RulesEngineStatus"){ literalAtributo = "Estado del motor de reglas"; }
  else if(atributo ===  "InstallationLongitude"){ literalAtributo = "Coordenada longitud instalación"; }
  else if(atributo ===  "InstallationLatitude"){ literalAtributo = "Coordenada latitud instalación"; }
  else if(atributo ===  "FVMaxGenerationEstimationMode"){ literalAtributo = "Modo aprendizaje motor estimación"; }
  else if(atributo ===  "ChargeLatchStatus"){ literalAtributo = "Estado del conector"; }
  else if(atributo ===  "MaximumChargeAmperage"){ literalAtributo = "Amperaje máximo de carga"; }
  else if(atributo ===  "CarLatitude"){ literalAtributo = "Coordenada de latitud"; }
  else if(atributo ===  "CarLongitude"){ literalAtributo = "Coordenada de longitud"; }
  else if(atributo ===  "WindSpeed"){ literalAtributo = "Velocidad viento"; }
  else if(atributo ===  "PrecipRate"){ literalAtributo = "Ritmo precipitaciones"; }
  else if(atributo ===  "Humidity"){ literalAtributo = "Humedad ambiental"; }
  else if(atributo ===  "UpdateTime"){ literalAtributo = "Fecha y hora de última actualización"; }
  else if(atributo ===  "AEMETUpdateTime"){ literalAtributo = "Fecha y hora de última actualización AEMET"; }
  else if(atributo ===  "QueryUpdateTime"){ literalAtributo = "Fecha y hora de última consulta"; }
  else if(atributo ===  "ProvinceName"){ literalAtributo = "Provincia"; }
  else if(atributo ===  "EnergyGridConnected"){ literalAtributo = "Instalación conectada a la red general"; }
  else if(atributo ===  "PowerContracted"){ literalAtributo = "Potencia contratada"; }
  else if(atributo ===  "GeneralWhInstallationTOTALGeneration"){ literalAtributo = "Tomado de la red"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP1"){ literalAtributo = "Tomado de la red - Fase 1"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP2"){ literalAtributo = "Tomado de la red - Fase 2"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP3"){ literalAtributo = "Tomado de la red - Fase 3"; }
  else if(atributo ===  "GeneralWhInstallationTOTALWastedEnergy"){ literalAtributo = "Devuelto a la red"; }
  else if(atributo ===  "BatteriesCurrentCapacity"){ literalAtributo = "Capacidad disponible"; }
  else if(atributo ===  "ForceBatteryChargeFromGrid"){ literalAtributo = "Forzado de carga de baterías desde la red"; }
  else if(atributo ===  "ForceSurplusSellToGrid"){ literalAtributo = "Forzado de venta de excedente a la red"; }  
  else if(atributo ===  "BatteriesMaxCapacity"){ literalAtributo = "Capacidad máxima"; }
  else if(atributo ===  "CityName"){ literalAtributo = "Municipio"; }
  else if(atributo ===  "MunicipalityId"){ literalAtributo = "ID AEMET del municipio"; }
  else if(atributo ===  "Forecasting"){ literalAtributo = "Bloque previsión meteorológica 7 días"; }
  else if(atributo ===  "NowForcasting"){ literalAtributo = "Bloque previsión meteorológica ahora"; }  
  else if(atributo ===  "EnergyBuyPrice"){ literalAtributo = "Precio de compra del kWh"; }  
  else if(atributo ===  "DailyAverageBuyPrice"){ literalAtributo = "Precio medio de compra diario"; }  
  else if(atributo ===  "DailyAverageSellPrice"){ literalAtributo = "Precio medio de venta diario"; }  
  else if(atributo ===  "DailyAverageSellPriceDaylight"){ literalAtributo = "Precio medio de venta diario diurno"; }  

  else if(atributo ===  "TodayPersonalAverageBuyPrice"){ literalAtributo = "Media personal de compra"; }  
  else if(atributo ===  "TodayPersonalAverageSellPrice"){ literalAtributo = "Media personal de venta"; }  

  else if(atributo ===  "=···BestBuyPrice"){ literalAtributo = "Igual al mejor precio de compra hoy"; }  
  else if(atributo ===  "=···WorstBuyPrice"){ literalAtributo = "Igual al peor precio de compra hoy"; }  
  else if(atributo ===  "<=···DailyAverageBuyPrice"){ literalAtributo = "Menor o igual que la tarifa media de compra diaria"; }  
  else if(atributo ===  ">···DailyAverageBuyPrice"){ literalAtributo = "Mayor que la tarifa media de compra diaria"; }  

  else if(atributo ===  "=···BestSellPrice"){ literalAtributo = "Igual al mejor precio de venta hoy"; }  
  else if(atributo ===  "=···WorstSellPrice"){ literalAtributo = "Igual al peor precio de venta hoy"; }  
  else if(atributo ===  "<=···DailyAverageSellPrice"){ literalAtributo = "Menor o igual que la tarifa media de venta diaria"; }  
  else if(atributo ===  ">···DailyAverageSellPrice"){ literalAtributo = "Mayor que la tarifa media de venta diaria"; }  
  else if(atributo ===  "<=···DailyAverageSellPriceDaylight"){ literalAtributo = "Menor o igual que la tarifa media de venta diaria diurna"; }  
  else if(atributo ===  ">···DailyAverageSellPriceDaylight"){ literalAtributo = "Mayor que la tarifa media de venta diaria diurna"; }  

  else if(atributo ===  "ElectricSystemType"){ literalAtributo = "Tipo de sistema eléctrico"; }  
  else if(atributo ===  "MainElectricConnectionSensorsInInstallation"){ literalAtributo = "Existen sensores de medición en acometida principal de la instalación"; }  
  else if(atributo ===  "CarID"){ literalAtributo = "Identificador"; }  
  else if(atributo ===  "FVStatus"){ literalAtributo = "Estado del inversor"; }  
  else if(atributo ===  "Hour"){ literalAtributo = "Hora"; }  
  else if(atributo ===  "Minute"){ literalAtributo = "Minuto"; }  
  else if(atributo ===  "Day"){ literalAtributo = "Día del mes"; } 
  else if(atributo ===  "WeekDay"){ literalAtributo = "Día de la semana"; }   
  else if(atributo ===  "Month"){ literalAtributo = "Mes"; }     
  else if(atributo ===  "TodayEnergeticUse"){ literalAtributo = "Total aprovechamiento energético"; }  
  else if(atributo ===  "TodayTotalGeneration"){ literalAtributo = "Total energia generada"; }  
  else if(atributo ===  "Todayconsumption"){ literalAtributo = "Total energia consumida"; }  
  else if(atributo ===  "TodayenergyRevenue"){ literalAtributo = "Energía vendida"; }  
  else if(atributo ===  "TodayenergyWaste"){ literalAtributo = "Energía comprada"; }  
  else if(atributo ===  "TodayfromGrid"){ literalAtributo = "Total energia tomada de la red"; }  
  else if(atributo ===  "TodaysavingsBalance"){ literalAtributo = "Balance factura"; }  
  else if(atributo ===  "TodayselfConsumption"){ literalAtributo = "Autoconsumo"; }  
  else if(atributo ===  "TodaytoGrid"){ literalAtributo = "Total energia devuelta a la red"; }  
  else if(atributo ===  "TodayusedEnergyCost"){ literalAtributo = "Coste energía consumida"; }  
  else if(atributo ===  "TodayGivenAwayMoney"){ literalAtributo = "Dinero regalado a compañía eléctrica"; }  
  else if(atributo ===  "CurrentMonthEnergeticUse"){ literalAtributo = "Mes - Total aprovechamiento energético"; }  
  else if(atributo ===  "CurrentMonthTotalGeneration"){ literalAtributo = "Mes - Total energia generada"; }  
  else if(atributo ===  "CurrentMonthconsumption"){ literalAtributo = "Mes - Total energia consumida"; }  
  else if(atributo ===  "CurrentMonthenergyRevenue"){ literalAtributo = "Mes - Energía vendida"; }  
  else if(atributo ===  "CurrentMonthenergyWaste"){ literalAtributo = "Mes - Energía comprada"; }  
  else if(atributo ===  "CurrentMonthfromGrid"){ literalAtributo = "Mes - Total energia tomada de la red"; }  
  else if(atributo ===  "CurrentMonthsavingsBalance"){ literalAtributo = "Balance factura"; }  
  else if(atributo ===  "CurrentMonthselfConsumption"){ literalAtributo = "Mes - Autoconsumo"; }  
  else if(atributo ===  "CurrentMonthtoGrid"){ literalAtributo = "Mes - Total energia devuelta a la red"; }  
  else if(atributo ===  "CurrentMonthusedEnergyCost"){ literalAtributo = "Mes - Coste energía consumida"; }  
  else if(atributo ===  "CurrentMonthGivenAwayMoney"){ literalAtributo = "Dinero regalado a compañía eléctrica"; }  
  else if(atributo ===  "YearEnergeticUse"){ literalAtributo = "Año - Total aprovechamiento energético"; }  
  else if(atributo ===  "YearTotalGeneration"){ literalAtributo = "Año - Total energia generada"; }  
  else if(atributo ===  "Yearconsumption"){ literalAtributo = "Año - Total energia consumida"; }  
  else if(atributo ===  "YearenergyRevenue"){ literalAtributo = "Año - Energía vendida"; }  
  else if(atributo ===  "YearenergyWaste"){ literalAtributo = "Año - Energía comprada"; }  
  else if(atributo ===  "YearfromGrid"){ literalAtributo = "Año - Total energia tomada de la red"; }  
  else if(atributo ===  "YearsavingsBalance"){ literalAtributo = "Año - Balance factura"; }  
  else if(atributo ===  "YearselfConsumption"){ literalAtributo = "Año - Autoconsumo"; }  
  else if(atributo ===  "YeartoGrid"){ literalAtributo = "Año - Total energia devuelta a la red"; }  
  else if(atributo ===  "YearusedEnergyCost"){ literalAtributo = "Año - Coste energía consumida"; }  
  else if(atributo ===  "SinceRegistrationEnergeticUse"){ literalAtributo = "Desde registro - Total aprovechamiento energético"; }  
  else if(atributo ===  "SinceRegistrationTotalGeneration"){ literalAtributo = "Desde registro - Total energia generada"; }  
  else if(atributo ===  "SinceRegistrationconsumption"){ literalAtributo = "Desde registro - Total energia consumida"; }  
  else if(atributo ===  "SinceRegistrationenergyRevenue"){ literalAtributo = "Desde registro - Energía vendida"; }  
  else if(atributo ===  "SinceRegistrationenergyWaste"){ literalAtributo = "Desde registro - Energía comprada"; }  
  else if(atributo ===  "SinceRegistrationfromGrid"){ literalAtributo = "Desde registro - Total energia tomada de la red"; }  
  else if(atributo ===  "SinceRegistrationsavingsBalance"){ literalAtributo = "Desde registro - Balance factura"; }  
  else if(atributo ===  "SinceRegistrationselfConsumption"){ literalAtributo = "Desde registro - Autoconsumo"; }  
  else if(atributo ===  "SinceRegistrationtoGrid"){ literalAtributo = "Desde registro - Total energia devuelta a la red"; }  
  else if(atributo ===  "SinceRegistrationusedEnergyCost"){ literalAtributo = "Desde registro - Coste energía consumida"; } 
  else if(atributo ===  "WorkingTimeAccumulatedFromDate"){ literalAtributo = "Horas de trabajo"; }   
  else if(atributo ===  "TodayPercentageReactive"){ literalAtributo = "% Reactiva"; }   
  else if(atributo ===  "TodayTotalReactive"){ literalAtributo = "Total reactiva"; }   
  else if(atributo ===  "EnergySellPrice"){ literalAtributo = "Precio venta kWh"; }   
  else if(atributo ===  "DailyEnergySellPrice"){ literalAtributo = "Precio venta kWh (PVPC)"; }   
  else if(atributo ===  "HistoricalMaxPowerConsumption"){ literalAtributo = "Consumo máximo histórico"; }   
  else if(atributo ===  "MarketAverageBuyPrice"){ literalAtributo = "Precio compra energia (PVPC)"; }   
  
  else if(atributo ===  "CurrentSolarWalletBalance"){ literalAtributo = "Monedero solar / Baterías virtuales - Saldo"; }   
  else if(atributo ===  "TodayselfConsumptionBalance"){ literalAtributo = "Balance autoconsumo"; }   
  else if(atributo ===  "CurrentMonthselfConsumptionBalance"){ literalAtributo = "Balance autoconsumo"; }   
  else if(atributo ===  "YearselfConsumptionBalance"){ literalAtributo = "Año - Balance autoconsumo"; }   
  else if(atributo ===  "SinceRegistrationselfConsumptionBalance"){ literalAtributo = "Desde registro - Balance autoconsumo"; }   
  
  else if(atributo ===  "CurrentMonthPercentageReactive"){ literalAtributo = "Mes - % Reactiva"; }   
  else if(atributo ===  "CurrentMonthTotalReactive"){ literalAtributo = "Mes - Total reactiva"; }   
  else if(atributo ===  "YearPercentageReactive"){ literalAtributo = "Año - % Reactiva"; }   
  else if(atributo ===  "YearTotalReactive"){ literalAtributo = "Año - Total reactiva"; }   
  else if(atributo ===  "SinceRegistrationPercentageReactive"){ literalAtributo = "Desde registro - % Reactiva"; }   
  else if(atributo ===  "SinceRegistrationTotalReactive"){ literalAtributo = "Desde registro - Total reactiva"; }   

  else if(atributo ===  "DailyCombustiblePrice"){ literalAtributo = "Precio combustible"; }   

  else if(atributo ===  "TodayGeneratorLitersConsumed"){ literalAtributo = "Litros combustible consumidos"; }   
  else if(atributo ===  "TodayGeneratorConsumptionCost"){ literalAtributo = "€ combustible consumidos"; }   
  else if(atributo ===  "CurrentMonthGeneratorLitersConsumed"){ literalAtributo = "Mes - Litros combustible consumidos"; }   
  else if(atributo ===  "CurrentMonthGeneratorConsumptionCost"){ literalAtributo = "Mes - € combustible consumidos"; }   
  else if(atributo ===  "YearGeneratorLitersConsumed"){ literalAtributo = "Año - Litros combustible consumidos"; }   
  else if(atributo ===  "YearGeneratorConsumptionCost"){ literalAtributo = "Año - € combustible consumidos"; }   
  else if(atributo ===  "SinceRegistrationGeneratorLitersConsumed"){ literalAtributo = "Desde registro - Litros combustible consumidos"; }   
  else if(atributo ===  "SinceRegistrationGeneratorConsumptionCost"){ literalAtributo = "Desde registro - € combustible consumidos"; }   

    else if(atributo ===  "PreviousMonthsSolarWalletBalance"){ literalAtributo = "Monedero solar / Baterías virtuales - Saldo mes anterior"; }   

  else if(atributo ===  "TodayPowerExcessesCount"){ literalAtributo = "Nº excesos de potencia"; }   
  else if(atributo ===  "TodayPowerExcessesPenalty"){ literalAtributo = "€ Penalización excesos potencia"; }   
  else if(atributo ===  "TodayReactivePenaltyAmount"){ literalAtributo = "Penalización energía reactiva"; }   
  
  else if(atributo ===  "CurrentMonthPowerExcessesCount"){ literalAtributo = "Mes - Nº excesos de potencia"; }   
  else if(atributo ===  "CurrentMonthPowerExcessesPenalty"){ literalAtributo = "Mes - € Penalización excesos potencia"; }   
  else if(atributo ===  "CurrentMonthReactivePenaltyAmount"){ literalAtributo = "Mes - € Penalización energía reactiva"; }   

  else if(atributo ===  "YearPowerExcessesCount"){ literalAtributo = "Año - Nº excesos de potencia"; }   
  else if(atributo ===  "YearPowerExcessesPenalty"){ literalAtributo = "Año - € Penalización excesos potencia"; }   
  else if(atributo ===  "YearReactivePenaltyAmount"){ literalAtributo = "Año - € Penalización energía reactiva"; }   
  
  else if(atributo ===  "SinceRegistrationPowerExcessesCount"){ literalAtributo = "Desde registro - Nº excesos de potencia"; }   
  else if(atributo ===  "SinceRegistrationPowerExcessesPenalty"){ literalAtributo = "Desde registro - € Penalización excesos potencia"; }   
  else if(atributo ===  "SinceRegistrationReactivePenaltyAmount"){ literalAtributo = "Desde registro - € Penalización energía reactiva"; }   
    
  //Gráfica economics  
  else if(atributo ===  "TituloGraficaEconomics"){ literalAtributo = "Historico consumo / gastos"; }   
  else if(atributo ===  "CurrentSolarWalletBalanceGraficaEconomics"){ literalAtributo = "Saldo monedero / batería virtual"; }   
  else if(atributo ===  "CurrentMonthsavingsBalanceGraficaEconomics"){ literalAtributo = "Factura"; }   
  else if(atributo ===  "CurrentMonthselfConsumptionBalanceGraficaEconomics"){ literalAtributo = "Ahorro por autoconsumo"; }   
      
  //Estados de carga del coche
  else if(atributo ===  "Desconectado"){ literalAtributo = "Desconectado"; }  
  else if(atributo ===  "Completada"){ literalAtributo = "Completada"; }  
  else if(atributo ===  "Parada"){ literalAtributo = "Parada"; }  
  else if(atributo ===  "Comenzando"){ literalAtributo = "Comenzando"; }  
  else if(atributo ===  "Cargando"){ literalAtributo = "Cargando"; }  
  else if(atributo ===  "Conectado"){ literalAtributo = "Conectado"; }  
  

  //Estado del conector de carga
  else if(atributo ===  "Bloqueado"){ literalAtributo = "Bloqueado"; }  
  
  //Nombres de aplicaciones
  else if(atributo ===  "EFERGY"){ literalAtributo = "Efergy"; }  
  else if(atributo ===  "EWELINK"){ literalAtributo = "Ewelink"; }  
  else if(atributo ===  "FUSIONSOLAR"){ literalAtributo = "FusionSolar"; }  
  else if(atributo ===  "SHELLY"){ literalAtributo = "Shelly"; }  
  else if(atributo ===  "SMARTLIFE"){ literalAtributo = "Smart Life"; }  
  else if(atributo ===  "TESLA"){ literalAtributo = "Tesla"; }  
  else if(atributo ===  "TPLINK"){ literalAtributo = "TPLINK KASA"; }  
  else if(atributo ===  "TUYA"){ literalAtributo = "Tuya"; }  
  else if(atributo ===  "VICTRON"){ literalAtributo = "VRM"; }  
  else if(atributo ===  "TAPO"){ literalAtributo = "TP-Link Tapo"; }  
  else if(atributo ===  "ARISTON"){ literalAtributo = "Ariston Net"; }  
  else if(atributo ===  "BRONPI"){ literalAtributo = "Bronpi Home"; }  
  else if(atributo ===  "SOLARWEB"){ literalAtributo = "Solar.web"; }  
  else if(atributo ===  "ECOFORESTCONTROL"){ literalAtributo = "Ecoforest Control"; }  
  else if(atributo ===  "BROADLINK"){ literalAtributo = "Broadlink"; }  
  else if(atributo ===  "HOME_ASSISTANT"){ literalAtributo = "Home Assistant"; }  
  else if(atributo ===  "KOSTAL"){ literalAtributo = "KOSTAL Solar App"; }  
  else if(atributo ===  "KOSTAL_LOCAL"){ literalAtributo = "KOSTAL (Servidor local)"; }  
  else if(atributo ===  "IBERDROLA_SMART_MONITOR"){ literalAtributo = "Iberdrola Smart Monitor"; }  
  else if(atributo ===  "EDP_SOLAR"){ literalAtributo = "EDP Solar"; }  
  else if(atributo ===  "ENERGEEKS_30"){ literalAtributo = "Energeeks 3.0"; }  
  else if(atributo ===  "SOLARMAN"){ literalAtributo = "SOLARMAN Smart"; }  
  else if(atributo ===  "ESAJ_HOME"){ literalAtributo = "eSAJ Home"; }    
  else if(atributo ===  "IAQUALINK"){ literalAtributo = "iAquaLink"; }    
  else if(atributo ===  "MELCLOUD"){ literalAtributo = "MELCloud"; }    
  else if(atributo ===  "COMFORT_CLOUD"){ literalAtributo = "Panasonic Comfort Cloud"; }    
  else if(atributo ===  "MEROSS"){ literalAtributo = "Meross"; }    
  else if(atributo ===  "ONECTA_DAIKIN"){ literalAtributo = "ONECTA - Daikin"; }    
  else if(atributo ===  "GOVEE"){ literalAtributo = "Govee Home"; }    
  else if(atributo ===  "XIAOMI"){ literalAtributo = "Mi Home - Xiaomi"; }    
  else if(atributo ===  "SMARTTHINGS"){ literalAtributo = "SmartThings"; }    

  else if(atributo ===  "GeneralData"){ literalAtributo = "Información general"; }    
  else if(atributo ===  "MeteoData"){ literalAtributo = "Meteorología"; }    
  else if(atributo ===  "InstallationData"){ literalAtributo = "Instalación"; }    
  else if(atributo ===  "InstallationData.GeneralInfo"){ literalAtributo = "Instalación"; }      
  else if(atributo ===  "FVData"){ literalAtributo = "Paneles solares"; }    
  else if(atributo ===  "BatteriesData"){ literalAtributo = "Baterías"; }      
  else if(atributo ===  "GeneratorData"){ literalAtributo = "Grupo electrógeno"; }    
  else if(atributo ===  "GrupoElectrogeno"){ literalAtributo = "Grupo electrógeno"; }      
  else if(atributo ===  "CarsData"){ literalAtributo = "Coche"; } 
  else if(atributo ===  "SelfConsumptionAndSavingsData"){ literalAtributo = "Economía"; }      
  else if(atributo ===  "Dispositivos"){ literalAtributo = "Dispositivos inteligentes"; }    
  else if(atributo ===  "Devices"){ literalAtributo = "Dispositivos inteligentes"; }    
  else if(atributo ===  "Schedule"){ literalAtributo = "Planificación horaria"; }     
  else if(atributo ===  "Mensajeria"){ literalAtributo = "Mensajería"; }     
  

  //Analizador de tarifas
  else if(atributo ===  "FA_SOON"){ literalAtributo = "Yo no me cambiaría todavía, necesito monitorizar más tiempo tu instalación para decirte algo definitivo"; }    
  else if(atributo ===  "FA_SOON_NO6P"){ literalAtributo = "Yo no me cambiaría todavía, me falta información de consumo de alguno de tus tramos para decirte algo definitivo"; }    
  else if(atributo ===  "FA_CHANGE"){ literalAtributo = "¿A qué estás esperando para cambiarte?"; }    
  else if(atributo ===  "FA_UP2U"){ literalAtributo = "No sé si es mucho o poco para ti, yo me cambiaría"; }    
  else if(atributo ===  "FA_VERY_LOW_SAVINGS"){ literalAtributo = "Ahorrarías poco"; }    
  else if(atributo ===  "FA_LOW_SAVINGS"){ literalAtributo = "Ahorrarías algo"; }    
  else if(atributo ===  "FA_MID_SAVINGS"){ literalAtributo = "Ahorrarías mucho"; }    
  else if(atributo ===  "FA_HIGH_SAVINGS"){ literalAtributo = "Ahorrarías muchísimo"; }    
  else if(atributo ===  "FA_NO_CHANGE"){ literalAtributo = "Tienes una buena tarifa, no la cambies"; }    
  else if(atributo ===  "FA_SAME"){ literalAtributo = "Te quedarías igual que estás"; }    
  else if(atributo ===  "FA_MORE_WASTE"){ literalAtributo = "Tienes una buena tarifa, no la cambies"; }    
  else if(atributo ===  "FA_WASTE"){ literalAtributo = "Tienes una buena tarifa, no la cambies"; }    
  else if(atributo ===  "FA_WIN"){ literalAtributo = "Ganarías"; }    
  else if(atributo ===  "FA_WALLET_POSITIVE"){ literalAtributo = "Todavía tienes saldo en el monedero solar. Yo me esperaría a gastarlo antes de cambiarme, tu decides..."; }    
  else if(atributo ===  "FA_NO_CHECK"){ literalAtributo = "Nunca se han revisado"; }    

  else { literalAtributo = atributo }
  

    
  return literalAtributo;
}

exports.obtenerIdInstalacion = function(){

  var idInstalacion = ""

  if(localStorage.getItem("installationId") !== null){
    idInstalacion = localStorage.getItem("installationId")
  }
  else{
    idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  }

  return idInstalacion
}

exports.actualizarPasoWorkflowEnBBDD = function(pasoWorkflow,setUpdateBillingPlans){  
  
  if( module.exports.existeSesion() && (localStorage.getItem("installationConfigurationMode") === null)){
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    

    if(!pasoWorkflow.includes("COMPLETED")){
      document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "")
    }    
    
    var inicializacion = false    
    var esInstalador = false
    var elementosInstalacion
    var nombreInstalacion

    if(localStorage.getItem('customizedWorkflow') !== null){
      elementosInstalacion = localStorage.getItem('customizedWorkflow')
    }
    else{
      elementosInstalacion = ""
    }
    
    //Actualizo en BBDD el paso actual en el que me encuentro del Workflow para la instalación actual
    var xhttp = new XMLHttpRequest();
    xhttp.open("PUT", putAccountIDInstallation, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = ""

    if(!pasoWorkflow.includes("INSTALLER")){ esInstalador = false }
    else{ esInstalador = true }

    if((localStorage.getItem("ongoingInstallationConfiguration") === "NEW") && ( (pasoWorkflow === "WELCOME_USER") || (pasoWorkflow === "WELCOME_INSTALLER") ) ){ //No hay instalación, inicializo

      console.log("Nueva instalación")        
      inicializacion = true
      data = JSON.stringify({"IdToken": lastAuthUserIdToken, "estadoConfiguracionInicial": pasoWorkflow, "nombreInstalacion": generalCommonJS.obtenerEmailUsuario()+"|#·", "stripeData": localStorage.getItem("stripeData")}); 
  
    }
    else{ //Hay instalacion, actualizo

      console.log("Instalación ya existente")
              
      if(localStorage.getItem("ongoingInstallationName") !== null){ 
        if(localStorage.getItem("ongoingInstallationName") !== ""){//Mientras no le haya seteado el nombre a la instalación pongo el email
          nombreInstalacion = localStorage.getItem("installationName") 
        }
        else{
          nombreInstalacion = localStorage.getItem("ongoingInstallationName") 
        }
      }
      else if(localStorage.getItem("installationName") !== null){ 
        if(localStorage.getItem("installationName") !== ""){//Mientras no le haya seteado el nombre a la instalación pongo el email
          nombreInstalacion = localStorage.getItem("installationName") 
        }
        else{
          nombreInstalacion = generalCommonJS.obtenerEmailUsuario() + "|#·"
        }
      }
      else{ 
        nombreInstalacion = generalCommonJS.obtenerEmailUsuario() + "|#·"
      }

      
      data = JSON.stringify({"IdToken": lastAuthUserIdToken, "idInstalacion": localStorage.getItem("ongoingInstallationConfiguration"), "estadoConfiguracionInicial": pasoWorkflow, "elementosInstalacion": elementosInstalacion, "nombreInstalacion": nombreInstalacion});                
        
    }

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {

        var jsonPutAccountIDInstallationResponse = JSON.parse(this.responseText).body;

        localStorage.setItem("ongoingInstallationConfiguration", jsonPutAccountIDInstallationResponse.installationId)
        localStorage.setItem("ongoingStepConfiguration", pasoWorkflow) 
        localStorage.setItem("accountID", jsonPutAccountIDInstallationResponse.accountID)    
        
        var jsonStripeData = jsonPutAccountIDInstallationResponse.subscriptionData

        localStorage.setItem("stripeData", JSON.stringify(jsonStripeData)) 

        try{
          setUpdateBillingPlans(new Date(Date.now()).getTime())
        }
        catch(error){ /* Controlo el caso de actualización cuando NO estemos en Welcome */ }

        if(esInstalador === false){
          //Si es inicialización...
          if(inicializacion){
                    
                var jsonGuardado = {
                    "accountID": jsonPutAccountIDInstallationResponse.accountID,
                    "installationID": jsonPutAccountIDInstallationResponse.installationId,
                    "GeneralInfo": "",
                    "Meteo": "",
                    "FV": "",
                    "Battery": "",
                    "Generator": "",    
                    "Cars": "",
                    "Messaging": ""
                }
                
                // Guardo la información  
                var xhttp1 = new XMLHttpRequest();  
                xhttp1.open("PUT", putInstallationConfiguration, true);        
                xhttp1.setRequestHeader('Content-Type', "application/json");
                xhttp1.setRequestHeader('Authorization', lastAuthUserIdToken);
                var data = JSON.stringify(jsonGuardado); 
                xhttp1.onreadystatechange = function() {              
                    
                    if (this.readyState === 4 && this.status === 200) {
                        var jsonRespuestaGuardado = JSON.parse(this.responseText)
                        if(jsonRespuestaGuardado.statusCode === "403"){                   
                          module.exports.mostrarErrorGeneral("report","OPERACIÓN NO AUTORIZADA", "No tiene permisos para realizar la operación.")
                        }
                        else{                  
                          console.log("Configuración de la instalación inicializada correctamente")
                        }
                    }
                
                    if (this.readyState === 4 && this.status !== 200) {                          
                      module.exports.gestionarRespuestaPeticionErronea(this.status)       
                    }
                }
                xhttp1.send(data);    

                
                //Ahora inicializo la tabla de monitorización para esta instalación
                jsonGuardado = {
                  "accountID": localStorage.getItem("accountID"),
                  "InstallationID": jsonPutAccountIDInstallationResponse.installationId,
                  "DashboardTimerRefresh": "60",
                  "LastAnalyticsUpdateDatetime": "2020-07-09T00:00:00",
                  "LastDashboardData": "",
                  "LastSmartDevicesStatus": "",
                  "FVEstimationPonderations": "",
                  "LastMeteoUpdate": {
                    "Weather": {},
                    "Astronomy":{}
                  },
                  "CarCachedStatus": "",
                  "GeneratorMonitoring": {
                    "FuelAccumulatedCostFromDate": {
                      "dateTime": "",
                      "unit": "€",
                      "amount": "0"
                    },
                    "WorkingTimeAccumulatedFromDate": {
                      "dateTime": "",
                      "unit": "Hrs",
                      "amount": "0"
                    },
                    "CurrentGeneratorTankLevel": {
                      "dateTime": "",
                      "unit": "L",
                      "amount": "0" 
                    },
                    "GeneratorLastStart": {
                      "dateTime": "",
                      "unit": "L",
                      "amount": "0"
                    },
                    "GeneratorLastStop": {
                      "dateTime": "",
                      "unit": "L",
                      "amount": "0"
                    },
                    "GeneratorLastReading": {
                      "dateTime": "",
                      "powerReading": "0"
                    }
                  }
                }
              
                // Guardo la información  
                var xhttp2 = new XMLHttpRequest();  
                xhttp2.open("PUT", putInstallationMonitoring, true);        
                xhttp2.setRequestHeader('Content-Type', "application/json");
                xhttp2.setRequestHeader('Authorization', lastAuthUserIdToken);
                data = JSON.stringify(jsonGuardado);
                xhttp2.onreadystatechange = function() {              
                    
                    if (this.readyState === 4 && this.status === 200) {
                        var jsonRespuestaGuardado = JSON.parse(this.responseText)
                        if(jsonRespuestaGuardado.statusCode === "403"){                   
                          module.exports.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
                        }
                        else{                  
                          console.log("Inicialización de la configuración de la monitorización realizada correctamente.")

                          if ( (pasoWorkflow.includes("WELCOME")) && (Object.keys(jsonStripeData).length !== 0) ){ //Si se vuelve al Welcome con datos de Stripe le mando a general info ya que seguramente esté creando una segunda instalación       
                            window.location.href = "/UserInitialConfig/GeneralInfo"                            
                          }

                        }
                    }
                
                    if (this.readyState === 4 && this.status !== 200) {                          
                      module.exports.gestionarRespuestaPeticionErronea(this.status)       
                    }
                }
                xhttp2.send(data);  

                document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

                console.log("Inicialización de la instalación realizada correctamente.")
          }
          else{

            var jsonSuscripcionStripe = JSON.parse(localStorage.getItem("stripeData"))
              
            var idSuscripcion = ""

            try{
              idSuscripcion = jsonSuscripcionStripe.subscriptionId
            }
            catch(error){}
            
            if(pasoWorkflow.includes("WELCOME")){

              if( (idSuscripcion !== "") && (Object.keys(jsonSuscripcionStripe).length !== 0) ){
                window.location.href = "/UserInitialConfig/GeneralInfo"                
              }

              document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"              
              
            } 
            else{ // Intento ir a cualquier otro paso del workflow
              if( (idSuscripcion === "") || (Object.keys(jsonSuscripcionStripe).length === 0) ){ //Si intenta saltarse el welcome sin suscripción lo llevo del vuelta al welcome
                window.location.href = "/UserInitialConfig/Welcome"                
              }
            }
                      
          }        
        }
        else{

          if(pasoWorkflow === "COMPLETED_INSTALLER"){ //Finalizado registro, lo mando al dashboard             
            window.location.href = "/"      
          }

        }

        if(!pasoWorkflow.includes("COMPLETED") && !pasoWorkflow.includes("WELCOME")){
          document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"
        }

        console.log("Paso actual del workflow actualizado correctamente.")
      }            
      if (this.readyState === 4 && this.status !== 200) {                        
        module.exports.gestionarRespuestaPeticionErronea(this.status)                   
      }            
    };
    xhttp.send(data); 
  

  }//Final if existe sesión
  else if(localStorage.getItem("installationConfigurationMode") !== null){
    localStorage.setItem("ongoingStepConfiguration", pasoWorkflow)
  }
  
}

exports.cargaInicialIlustracion = function(configuracionActual){

  var elementosImagen = []

  if(configuracionActual.length !== 0){

    try{
      if(configuracionActual.GeneralInfo !== ""){ 
        elementosImagen.push("HOUSE")    
        if(configuracionActual.GeneralInfo.EnergyGridConnected === "true"){ elementosImagen.push("GRID_CONNECTED")  }    
      }
      else{//Default
        elementosImagen.push("HOUSE")
        elementosImagen.push("GRID_CONNECTED") 
      }    
    }
    catch(error){
      elementosImagen.push("HOUSE")
      elementosImagen.push("GRID_CONNECTED") 
    }
    
    try{
      if(configuracionActual.FV !== ""){ elementosImagen.push("FV") }  
      else{//Default
        if(localStorage.getItem("customizedWorkflow") !== null){
          if(localStorage.getItem("customizedWorkflow").includes("FV")){ elementosImagen.push("FV") }
        }
      }   
    }
    catch(error){}

    try{
      if(configuracionActual.Battery !== ""){
        if(configuracionActual.Battery.BatteriesTemperatureSensor === "TEMPFIJA"){ elementosImagen.push("BATTERY_IN") }
        else { elementosImagen.push("BATTERY_OUT") }
      }
      else{//Default      
        if(localStorage.getItem("customizedWorkflow") !== null){        
          if(localStorage.getItem("customizedWorkflow").includes("BATTERY")){           
            elementosImagen.push("BATTERY_IN") }
        }
      }   
    }
    catch(error){}
    
    try{
      if(configuracionActual.Generator !== ""){ elementosImagen.push("GENERATOR") }
      else{//Default
        if(localStorage.getItem("customizedWorkflow") !== null){
          if(localStorage.getItem("customizedWorkflow").includes("GENERATOR")){ elementosImagen.push("GENERATOR") }
        }
      }  
    }
    catch(error){}

    try{
      if(configuracionActual.Cars !== "" ){
        elementosImagen.push("CARS")
        if( (configuracionActual.Cars.CarType === "ELECTRICO") || (configuracionActual.Cars.CarType === "HIBRIDO") ){ elementosImagen.push("CAR_CHARGER") }      
      }
      else{//Default
        if(localStorage.getItem("customizedWorkflow") !== null){
          if(localStorage.getItem("customizedWorkflow").includes("CARS")){ 
            elementosImagen.push("CARS") 
            elementosImagen.push("CAR_CHARGER") //Default ELECTRICO
          }
        }
      }  
    }
    catch(error){}

    try{
      if(localStorage.getItem("customizedWorkflow") !== null){
        if(localStorage.getItem("customizedWorkflow").includes("DEVICES")){ elementosImagen.push("DEVICES") }
      }
    }
    catch(error){}
    
  }
  else{
    elementosImagen.push("HOUSE")
    elementosImagen.push("GRID_CONNECTED") 
  }

  return elementosImagen

}

exports.modificarIlustracion = function(illustrationElements, operacion, elemento){

  var elementosTemp = []
  var posicionElemento = ""

  for(var x=0; x<illustrationElements.length; x++){        
    elementosTemp.push(illustrationElements[x])         
  }

  //Añado los que haya en customizedWorkflow (sólo si no estoy en InstallationElements)
  if ( (localStorage.getItem("ongoingStepConfiguration") !== "INSTALLATION_ELEMENTS") && (localStorage.getItem("customizedWorkflow") !== null) ){
    if( (localStorage.getItem("customizedWorkflow").includes("GENERATOR")) && (!elementosTemp.includes("GENERATOR")) ){elementosTemp.push("GENERATOR")}
    if( (localStorage.getItem("customizedWorkflow").includes("CARS")) && (!elementosTemp.includes("CARS")) ){elementosTemp.push("CARS")}
    if( (localStorage.getItem("customizedWorkflow").includes("DEVICES")) && (!elementosTemp.includes("DEVICES")) ){elementosTemp.push("DEVICES")}
  }

  if(operacion === "agregar"){//Agregar          
    if(elementosTemp.indexOf(elemento) === -1){ 
      elementosTemp.push(elemento)         
    }
  }
  else{//Quitar       
    posicionElemento = elementosTemp.indexOf(elemento)
    if( posicionElemento !== -1){ //Existe y lo elimino     
      elementosTemp.splice(posicionElemento, 1) 
    }

    //Controlo casos especiales
    if(elemento === "CARS"){
      posicionElemento = elementosTemp.indexOf("CAR_CHARGER")
      if( posicionElemento !== -1){ //Existe y lo elimino     
        elementosTemp.splice(posicionElemento, 1) 
      }
    }

  }

  //Controlo casos especiales
  if(elemento === "BATTERY_IN"){
    posicionElemento = elementosTemp.indexOf("BATTERY_OUT")
    if( posicionElemento !== -1){ //Existe y lo elimino     
      elementosTemp.splice(posicionElemento, 1) 
    }
  }
      
  if(elemento === "BATTERY_OUT"){
    posicionElemento = elementosTemp.indexOf("BATTERY_IN")
    if( posicionElemento !== -1){ //Existe y lo elimino     
      elementosTemp.splice(posicionElemento, 1) 
    }
  }

  return elementosTemp

}

exports.procesarAppsConfiguradas = function(jsonRespuesta, setAvailableApps){

  var listAplicacionesRegistradas = []

  var objRespuestaCuentasExistentes = JSON.parse(JSON.stringify(jsonRespuesta))
            
  for (var i = 0; i < objRespuestaCuentasExistentes.length; i++) {  
    if(objRespuestaCuentasExistentes[i].Aplicacion !== "TELEGRAM"){
      listAplicacionesRegistradas.push(objRespuestaCuentasExistentes[i])
    }                
  }          
  
  //Si no hay datos configurados entonces no hago nada
  console.log("Información cargada correctamente")        

  if(setAvailableApps !== undefined){

    if(listAplicacionesRegistradas.length === 0 ){
      
      if(document.getElementById("botonEliminarAplicacionPasoDevices") !== null){
        document.getElementById("botonEliminarAplicacionPasoDevices").className = document.getElementById("botonEliminarAplicacionPasoDevices").className.replaceAll(" hidden","") + " hidden"
      }
      
    }
    else{
      
      if(document.getElementById("botonEliminarAplicacionPasoDevices") !== null){
        document.getElementById("botonEliminarAplicacionPasoDevices").className = document.getElementById("botonEliminarAplicacionPasoDevices").className.replaceAll(" hidden", "")            
      }

      
      //Si no es onboarding no hago nada ya que lo cargo al acceder

    }

    setAvailableApps(listAplicacionesRegistradas)      

    localStorage.setItem("configuredApps",JSON.stringify(listAplicacionesRegistradas))

  }        
  
  if( (localStorage.getItem("ongoingStepConfiguration") !== "MESSAGING_USER") && (localStorage.getItem("ongoingStepConfiguration") !== "MESSAGING_INSTALLER") ){
    module.exports.resetearAplicacionesDisponibles()        
    module.exports.ocultarAppsYaConfiguradas(listAplicacionesRegistradas)
    module.exports.mostrarAplicacionesValidas("","listadoAppsDispositivosInteligentes")
  }  

  if(document.getElementById("loaderAppsConfiguradas") !== null){
    document.getElementById("loaderAppsConfiguradas").className="loader hidden"
  } 
  
}

exports.CargarCuentasAplicacionesRegistradas = function(setAvailableApps){   

    try{
      document.getElementById("loaderDetalleInstallationConfiguration").className = document.getElementById("loaderDetalleInstallationConfiguration").className.replaceAll(" hidden", "")
    }catch(error){}

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
    
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID    
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", getHelias3pCredentials, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
        
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)
        if(jsonRespuesta.statusCode === "403"){                   
          module.exports.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{                      
          
          module.exports.procesarAppsConfiguradas(jsonRespuesta.body, setAvailableApps)
        }
        if (this.readyState === 4 && this.status !== 200) {                          
          module.exports.gestionarRespuestaPeticionErronea(this.status)       
        }

        try{
          document.getElementById("loaderDetalleInstallationConfiguration").className = document.getElementById("loaderDetalleInstallationConfiguration").className.replaceAll(" hidden", "") + " hidden"
        }catch(error){}

      }
    }    
    xhttp.send(data);  
  
}

exports.configurarDispositivo = function(idCampoDispositivo){

  localStorage.setItem("deviceToConfigure", idCampoDispositivo)

  //Filtro las aplicaciones ya configuradas disponibles para este paso    
  module.exports.mostrarAplicacionesValidas(localStorage.getItem("deviceToConfigure"),"listadoAplicacionesConfiguradasParaEstePaso")

  module.exports.operarMenuLateral("abrir")

  //Si no tiene apps configuradas le llevo directamente al listado de disponibles.
  if(!document.getElementById("mensajeSinAplicacionesCompatibles").className.includes(" hidden")){            
    document.getElementById("botonAñadirAplicacion").click()          
  }      

}

exports.visibilidadModoConfiguracion = function(){

  document.getElementById("divMainContenedorStep").className = "no-background"      
  document.getElementById("stepIntroBubble").className += " hidden"     
  document.getElementById("divContenedorStep").className = document.getElementById("divContenedorStep").className.replace("half","")    

}

exports.operarMenuLateral = function(accion){  
  
  if(document.getElementById("contenedorPrincipalOpcion") !== null){
    document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
  }  

  if(accion === "abrir"){
    document.getElementById("menuLateral").className = "modal"
    document.getElementById("listadoAplicacionesConfiguradas").style = "display"
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"    
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("errorBorradoAplicacion").style = "display: none"
    document.getElementById("divMensajeError").className = document.getElementById("divMensajeError").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("campoUsuario1").value=""
    document.getElementById("campoUsuario2").value=""
    document.getElementById("campoUsuario3").value=""
    document.getElementById("campoContraseña").value=""
    document.getElementById("campoToken").value=""    
  }else{
    document.getElementById("menuLateral").className = "modal hidden"
    document.getElementById("loaderAppsConfiguradas").className="loader hidden"
    document.getElementById("loaderRegistroAplicacion").className="loader hidden"
    document.getElementById("divConfigurarSinDireccion").className = document.getElementById("divConfigurarSinDireccion").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("campoUsuario1").value=""
    document.getElementById("campoUsuario2").value=""
    document.getElementById("campoUsuario3").value=""
    document.getElementById("campoContraseña").value=""
    document.getElementById("campoToken").value=""
  }
  
}

exports.operarMenuMapaLateral = function(accion){  
  if(accion === "abrir"){
    document.getElementById("menuLateralMeteo").className = "modal meteo"            
  }else{
    document.getElementById("menuLateralMeteo").className = "modal hidden"    
  }
  
}

exports.ocultarAppsYaConfiguradas = function(appsList){    
  var listadoAplicacionesBuscador = document.getElementById("listadoAplicacionesBuscador").children
  var idElementoTemp = ""  

  for (var x = 0; x < appsList.length; x++) {        
      idElementoTemp = appsList[x].Aplicacion

      for (var i = 0; i < listadoAplicacionesBuscador.length; i++) {                    
          if(listadoAplicacionesBuscador[i].id.includes(idElementoTemp.toUpperCase())){
              document.getElementById(idElementoTemp).style="display: none" 
              document.getElementById(idElementoTemp).setAttribute("searchvisibility","#")              
          }                 
      }
  }
}

exports.borrarAplicacion = function(aplicacion, appsParam, ReactGA){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
  var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    

  if( document.getElementById("loaderDispositivosDisponibles") !== null ){
    document.getElementById("loaderDispositivosDisponibles").className="loader overlay"
    module.exports.cerrarMensajeBorrado()
  }
  else{
    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
  }
    
  var xhttp = new XMLHttpRequest();  
  xhttp.open("DELETE", deleteHelias3pCredentials, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
  
  //Esto habrá que hacerlo multiselect cuando Nico me pase la maqueta/estilos    
  var data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "aplicacion": aplicacion })
  xhttp.onreadystatechange = function() {
      
    if (this.readyState === 4 && this.status === 200) {

      var jsonRespuestaDispositivos = JSON.parse(this.responseText)

      if(jsonRespuestaDispositivos.statusCode === "200"){        

        localStorage.removeItem("configuredApps")

        if(localStorage.getItem("ongoingStepConfiguration") === "DEVICES"){
          console.log("Entro por setDevicesApps")
          module.exports.CargarCuentasAplicacionesRegistradas(appsParam.setDevicesApps)
        }
        else{
          console.log("Entro por setAvailableApps")
          module.exports.CargarCuentasAplicacionesRegistradas(appsParam.setAvailableApps)
        }            

        try{
          generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'APP Eliminada - '+aplicacion, "", "")
        }
        catch(error){console.log(error)}

        console.log("Cuenta borrada correctamente")  

        localStorage.removeItem("telegramAccount")

        if( (localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_USER") || (localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_INSTALLER") ){        
          module.exports.mostrarMensajeInformativo("Tu cuenta de Telegram ha sido dada de baja de mi agenda correctamente.","positive")              
        }
        else{
          module.exports.operarMenuLateral("cerrar")
          module.exports.mostrarMensajeInformativo("La aplicación se ha eliminado correctamente.","positive")    

          window.location.reload()
        }  
        

        if(localStorage.getItem("deviceToConfigure") !== null){
          module.exports.inicializarCampoSelector(localStorage.getItem("deviceToConfigure"))
        }

        if(localStorage.getItem("installationConfigurationMode") !== null){
          localStorage.setItem("forceUpdate", "true")
        }
                
        if(document.getElementById("asideDetalleConfiguracion") !== null){
          document.getElementById("asideDetalleConfiguracion").className += " hidden"          
        }
      }
      else if(jsonRespuestaDispositivos.statusCode === "403"){
        appsParam.setAppToRegister(aplicacion)
        appsParam.setDeletionConflictDevices(jsonRespuestaDispositivos.body)
        
        module.exports.navegarFlujoAplicacionesDispositivos("errorBorradoAplicacion","noUpdate")        
      }
      else{                    
        module.exports.mostrarMensajeInformativo("Hubo algún problema al eliminar la aplicación, inténtalo de nuevo en unos minutos.","negative")     
      }

      if( (localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_USER") || (localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_INSTALLER") ){        
        document.getElementById("fieldsetRegistroTelegram").style = "display."
        document.getElementById("nombreUsuarioTelegram").value = ""
        document.getElementById("nombreUsuarioTelegram").placeholder = ""
        document.getElementById("fieldsetYaRegistradoTelegram").style = "display: none"
      }

      if((document.getElementById("loaderDispositivosDisponibles") !== null)){
        document.getElementById("loaderDispositivosDisponibles").className="loader hidden"
      }
      else{
        document.getElementById("loaderGeneralAplicacion").className="loader hidden"
      }

    }
    if (this.readyState === 4 && this.status !== 200) {                          
      module.exports.gestionarRespuestaPeticionErronea(this.status)       
    }
  }
  xhttp.send(data);    

}

exports.eliminarConfiguracion = function(){
  
  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
  var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
  var ongoingStepConfiguration = localStorage.getItem("ongoingStepConfiguration")  
  
  if(document.getElementById("loaderDetalleInstallationConfiguration") !== null){
    document.getElementById("loaderDetalleInstallationConfiguration").className="loader overlay"
    document.getElementById("loaderDetalleInstallationConfigurationLabel").innerHTML = "Eliminando configuración"
  }
  else{
    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
    document.getElementById("loaderGeneralAplicacionLabel").innerHTML = "Eliminando configuración"
  }
  
  var jsonGuardado = {}

  var borrarAplicacionCoche = false

  if(ongoingStepConfiguration === "FV"){ jsonGuardado = { "accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "FV": "" } }
  else if(ongoingStepConfiguration === "BATTERY"){ jsonGuardado = { "accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "Battery": "" } }
  else if(ongoingStepConfiguration === "GENERATOR"){ jsonGuardado = { "accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "Generator": "" } }
  else if(ongoingStepConfiguration === "CARS"){ 
    jsonGuardado = { "accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "Cars": "" } 
    borrarAplicacionCoche = true
  }
  
  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", updateInstallationConfiguration, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonGuardado);
    xhttp.onreadystatechange = function() {
      
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuestaGuardado = JSON.parse(this.responseText)
        if(jsonRespuestaGuardado.statusCode === "403"){                   
          module.exports.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          

          try{
            if(borrarAplicacionCoche){
              var aplicacion = document.getElementById("car").value.split("|")[0]
              var appsParam = {
                "setDevicesApps": "[]",
                "setAvailableApps": "[]"
              }    
              var ReactGA = ""

              module.exports.borrarAplicacion(aplicacion, appsParam, ReactGA)
            }

          }
          catch(error){console.log(error)}

          console.log("Información guardada correctamente")
          
          if(document.getElementById("loaderDetalleInstallationConfiguration") !== null){
            document.getElementById("loaderDetalleInstallationConfiguration").className="loader hidden"
          }
          else{
            document.getElementById("loaderGeneralAplicacion").className="loader hidden"
          }
          
          if(document.getElementById("asideDetalleConfiguracion") !== null){
            document.getElementById("asideDetalleConfiguracion").className += " hidden"
          }
          
          module.exports.mostrarMensajeInformativo("Configuración eliminada correctamente.","positive")   
          
          if(localStorage.getItem("installationConfigurationMode") !== null){
            var objDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

            if(ongoingStepConfiguration === "FV"){ objDashboard.FVData = {} }
            else if(ongoingStepConfiguration === "BATTERY"){ objDashboard.BatteriesData = {} }
            else if(ongoingStepConfiguration === "GENERATOR"){ objDashboard.GeneratorData = {} }
            else if(ongoingStepConfiguration === "CARS"){ objDashboard.CarsData = {} }
  
            localStorage.setItem("lastDashboardData", JSON.stringify(objDashboard))
  
            module.exports.cargarOpcionesConfiguracionInstalacion()            
          }
          else{
            localStorage.setItem("customizedWorkflow" , localStorage.getItem("customizedWorkflow").replaceAll(localStorage.getItem("ongoingStepConfiguration"), "" ) )
            localStorage.setItem("customizedWorkflow" , localStorage.getItem("customizedWorkflow").replaceAll(",,",",") )
            window.location.href = '/InitialConfig/InstallationElements'
          }
          
        }
      }

      if (this.readyState === 4 && this.status !== 200) {                          
        module.exports.mostrarMensajeInformativo("Se produjo un error al eliminar la configuración.","negative")
        module.exports.gestionarRespuestaPeticionErronea(this.status)       
      }
    }
    xhttp.send(data);     

}

exports.cargarOpcionesConfiguracionInstalacion = function(){
    
  var objDatosDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))
  var objDatosDispositivos = JSON.parse(localStorage.getItem("lastSmartDevicesStatus"))

  if( (objDatosDashboard !== null) && (Object.keys(objDatosDashboard).length > 0)){
    
    if(Object.keys(objDatosDashboard.FVData).length > 0){        
        document.getElementById("botonPanelesSolares").className = "selection icon-wrapper"
        document.getElementById("figuraPanelesSolares").className = "avatar size-m cyan"        
        document.getElementById("spanAñadirPaneles").className = "link hidden"
    }
    else{
        document.getElementById("botonPanelesSolares").className = "selection horizontal no-icon"
        document.getElementById("figuraPanelesSolares").className = "avatar size-m"        
        document.getElementById("spanAñadirPaneles").className = "link"
    }

    if(Object.keys(objDatosDashboard.BatteriesData).length > 0){
        document.getElementById("botonBaterias").className = "selection icon-wrapper"
        document.getElementById("figuraBaterias").className = "avatar size-m cyan"   
        document.getElementById("spanAñadirBaterias").className = "link hidden"
    }
    else{
        document.getElementById("botonBaterias").className = "selection horizontal no-icon"
        document.getElementById("figuraBaterias").className = "avatar size-m"        
        document.getElementById("spanAñadirBaterias").className = "link"
    }

    if(Object.keys(objDatosDashboard.GeneratorData).length > 0){
        document.getElementById("botonGrupoElectrogeno").className = "selection icon-wrapper"
        document.getElementById("figuraGrupoElectrogeno").className = "avatar size-m cyan"   
        document.getElementById("spanAñadirGrupoElectrogeno").className = "link hidden"
    }
    else{
        document.getElementById("botonGrupoElectrogeno").className = "selection horizontal no-icon"
        document.getElementById("figuraGrupoElectrogeno").className = "avatar size-m"        
        document.getElementById("spanAñadirGrupoElectrogeno").className = "link"
    }

    if(objDatosDashboard.CarsData.length > 0){
        document.getElementById("botonCoche").className = "selection icon-wrapper"
        document.getElementById("figuraCoche").className = "avatar size-m cyan"   
        document.getElementById("spanAñadirCoche").className = "link hidden"
    }
    else{
        document.getElementById("botonCoche").className = "selection horizontal no-icon"
        document.getElementById("figuraCoche").className = "avatar size-m"        
        document.getElementById("spanAñadirCoche").className = "link"
    }
  }

  if(objDatosDispositivos !== null){
    if(objDatosDispositivos.length > 0){
        document.getElementById("botonDispositivosInteligentes").className = "selection icon-wrapper"
        document.getElementById("figuraDispositivosInteligentes").className = "avatar size-m cyan"   
        document.getElementById("spanAñadirDispositivosInteligentes").className = "link hidden"
    }
    else{

        if ( (localStorage.getItem("ongoingStepConfiguration") !== null) && (!localStorage.getItem("ongoingStepConfiguration").includes("INSTALLER")) ){
          document.getElementById("botonDispositivosInteligentes").className = "selection horizontal no-icon"
          document.getElementById("figuraDispositivosInteligentes").className = "avatar size-m"        
          document.getElementById("spanAñadirDispositivosInteligentes").className = "link"
        }
        
    }
  }

}

exports.resetearAplicacionesDisponibles = function(){    
  
  var listadoAplicacionesBuscador = document.getElementById("listadoAplicacionesBuscador").children
    for (var i = 0; i < listadoAplicacionesBuscador.length; i++) {                        
    if(document.getElementById(listadoAplicacionesBuscador[i].id).getAttribute("searchvisibility").includes("#")){
      document.getElementById(listadoAplicacionesBuscador[i].id).style="display"      
      document.getElementById(listadoAplicacionesBuscador[i].id).setAttribute("searchvisibility",listadoAplicacionesBuscador[i].id)      
    }       
  }   

}

exports.cargarListaDispositivos = function(aplicacion, setAvailableDevices){
  
  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
  var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    

  document.getElementById("divLoaderDevices").className="loader overlay"
  document.getElementById("fieldsetDispositivos").className = document.getElementById("fieldsetDispositivos").className.replaceAll(" hidden", "")
  document.getElementById("mensajeProblemaGeneralAplicacion3p").className = document.getElementById("mensajeProblemaGeneralAplicacion3p").className.replaceAll(" hidden", "") + " hidden"
    
  if (aplicacion !== "") {    
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postInitialConfigDevicesList, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    
    var camposSensores = module.exports.obtenerCamposSensores()
    var camposDispositivos = module.exports.obtenerCamposDispositivos()
    var camposCoches = module.exports.obtenerCamposCoches()
    
    var data = ""
    
    if(camposSensores.toString().includes(localStorage.getItem("deviceToConfigure"))){
      data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": aplicacion, "Usuario": "", "Contraseña": "", "Token": "" })
    }
    else if( (camposDispositivos.toString().includes(localStorage.getItem("deviceToConfigure"))) || (localStorage.getItem("ongoingStepConfiguration") === "DEVICES") ){
      data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": aplicacion, "Usuario": "", "Contraseña": "", "Token": "", "TipoPeticion": "DEVICES"})
    }
    else if(camposCoches.toString().includes(localStorage.getItem("deviceToConfigure"))){
      data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": aplicacion, "Usuario": "", "Contraseña": "", "Token": "" })
    }
    else{ //Default
      data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": aplicacion, "Usuario": "", "Contraseña": "", "Token": "" })
    }    
    
    xhttp.onreadystatechange = function() {
      
      if (this.readyState === 4 && this.status === 200) {        
        var jsonRespuestaDispositivos = JSON.parse(this.responseText)
        
        setAvailableDevices(jsonRespuestaDispositivos.body)  
        console.log("Dispositivos cargados correctamente")   
        
        document.getElementById("divLoaderDevices").className="loader hidden"                

      }

      if (this.readyState === 4 && this.status !== 200) {   
        
        document.getElementById("divLoaderDevices").className="loader hidden"
        document.getElementById("mensajeProblemaGeneralAplicacion3p").className = document.getElementById("mensajeProblemaGeneralAplicacion3p").className.replaceAll(" hidden", "")        
        document.getElementById("fieldsetDispositivos").className = document.getElementById("fieldsetDispositivos").className.replaceAll(" hidden", "") + " hidden"      
        
        
        //module.exports.gestionarRespuestaPeticionErronea(this.status) 

      }
    }
    xhttp.send(data);    
  }
  else{
    module.exports.mostrarMensajeInformativo("Los parámetros son incorrectos, error.","negative")
  }
}

exports.navegarDinamico = function(direccion){        

  //Calculo la redirección
  var pasoActual = localStorage.getItem("ongoingStepConfiguration")
  var elementosNavegacion = localStorage.getItem("customizedWorkflow")

  if(elementosNavegacion !== null){
    elementosNavegacion = localStorage.getItem("customizedWorkflow").split(",")     
    var posicionPasoActual = elementosNavegacion.indexOf(pasoActual)
  }
  
  var redireccion = ""

  //1. Pasos fijos
  if(pasoActual === "GENERAL_INFO_USER"){    
    if(direccion==="continuar"){ redireccion = "METEO" }
    else{ redireccion = "WELCOME_USER" }    
  }
  else if(pasoActual === "GENERAL_INFO_INSTALLER"){    
    if(direccion==="continuar"){ redireccion = "MESSAGING_INSTALLER" }
    else{ redireccion = "WELCOME_INSTALLER" }    
  }
  else if(pasoActual === "METEO"){    
    if(direccion==="continuar"){ redireccion = "INSTALLATION_ELEMENTS" }
    else{ redireccion = "GENERAL_INFO_USER" }    
  }  
  else if ((pasoActual === "COMPLETED_USER") || (pasoActual === "COMPLETED_INSTALLER") ){    
    if(direccion==="continuar"){ 
      localStorage.removeItem("ongoingStepConfiguration")
      localStorage.removeItem("ongoingInstallationConfiguration")     
      localStorage.removeItem("customizedWorkflow")  
      redireccion = "MAIN" 
    }    
    else{ 
      if(pasoActual === "COMPLETED_USER"){
        redireccion = "MESSAGING_USER" 
      }else{
        redireccion = "MESSAGING_INSTALLER" 
      }      
    }    
  }  

  //2. Pasos inicial y final de la parte dinámica
  else if(pasoActual === "INSTALLATION_ELEMENTS"){    
    if(direccion==="continuar"){
      if( elementosNavegacion.length === 2){ redireccion = "MESSAGING_USER" }
      else{ redireccion = elementosNavegacion[1] }
    }
    else{ redireccion = "METEO" }    
  }
  else if(pasoActual === "MESSAGING_USER"){    
    if(direccion==="continuar"){ redireccion = "FINAL_INFO_USER" }
    else{
      if( elementosNavegacion.length === 2){ redireccion = "INSTALLATION_ELEMENTS" }
      else{ redireccion = elementosNavegacion[elementosNavegacion.length-2] }
    }    
  }
  else if(pasoActual === "MESSAGING_INSTALLER"){    
    if(direccion==="continuar"){ redireccion = "FINAL_INFO_INSTALLER" }
    else{ redireccion = "GENERAL_INFO_INSTALLER" }
  }

  //3. Pasos intermedios dinámicos
  else{ 
    if(direccion==="continuar"){ redireccion = elementosNavegacion[posicionPasoActual+1] }
    else{ redireccion = elementosNavegacion[posicionPasoActual-1] }
  }

  //4. Finalmente redirijo

  if(localStorage.getItem("ongoingStepConfiguration") !== redireccion ){      
  
    if(redireccion === "WELCOME_USER"){window.location = "/UserInitialConfig/Welcome"}
    else if(redireccion === "WELCOME_INSTALLER"){window.location = "/InstallerInitialConfig/Welcome"}
    else if(redireccion === "GENERAL_INFO_USER"){window.location = "/UserInitialConfig/GeneralInfo"}
    else if(redireccion === "GENERAL_INFO_INSTALLER"){window.location = "/InstallerInitialConfig/GeneralInfo"}
    else if(redireccion === "METEO"){window.location = "/UserInitialConfig/Meteo"}
    else if(redireccion === "INSTALLATION_ELEMENTS"){window.location = "/UserInitialConfig/InstallationElements"}
    else if(redireccion === "FV"){window.location = "/UserInitialConfig/FV"}
    else if(redireccion === "BATTERY"){window.location = "/UserInitialConfig/Battery"}
    else if(redireccion === "GENERATOR"){window.location = "/UserInitialConfig/Generator"}
    else if(redireccion === "DEVICES"){window.location = "/UserInitialConfig/Devices"}
    else if(redireccion === "CARS"){window.location = "/UserInitialConfig/Cars"}
    else if(redireccion === "MESSAGING_USER"){window.location = "/UserInitialConfig/Messaging"}
    else if(redireccion === "MESSAGING_INSTALLER"){window.location = "/InstallerInitialConfig/Messaging"}
    else if(redireccion === "FINAL_INFO_USER"){window.location = "/UserInitialConfig/FinalStep"}
    else if(redireccion === "FINAL_INFO_INSTALLER"){window.location = "/InstallerInitialConfig/FinalStep"}
    else if(redireccion === "MAIN"){window.location = "/"}    

    
  }
  else{
    module.exports.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
  }

}

exports.saltarPaso = function (){    
  module.exports.navegarDinamico("continuar")
  localStorage.setItem("customizedWorkflow", localStorage.getItem("customizedWorkflow").replace(localStorage.getItem("ongoingStepConfiguration")+",",""))
}

exports.filtrarAplicaciones = function(){
  var cadenaFiltrado = document.getElementById("textoBuscador").value   
  var listadoAplicacionesBuscador = document.getElementById("listadoAplicacionesBuscador").children

  var idElementoTemp = ""    

  for (var i = 0; i < listadoAplicacionesBuscador.length; i++) {
      idElementoTemp = listadoAplicacionesBuscador[i].id
      
      if( (idElementoTemp.includes(cadenaFiltrado.toUpperCase())) && (!document.getElementById(idElementoTemp).getAttribute("searchvisibility").includes("#")) ){
          document.getElementById(idElementoTemp).style="display" 
      }
      else{
          document.getElementById(idElementoTemp).style="display: none" 
      }
  }    

}

exports.navegarFlujoAplicacionesDispositivos = function(paso, setSelecteDeviceToConfigure){
  
  document.getElementById("campoUsuario1").value = ""
  document.getElementById("campoUsuario2").value = ""
  document.getElementById("campoUsuario3").value = ""
  document.getElementById("campoContraseña").value = ""
  document.getElementById("campoToken").value = ""  

  if(paso === "listadoAplicacionesConfiguradas"){    
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display"        
    document.getElementById("errorBorradoAplicacion").style = "display: none"        
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"    
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display: none"    
    document.getElementById("divConfigurarSinDireccion").style = "display: none"
    module.exports.mostrarAplicacionesValidas(localStorage.getItem("deviceToConfigure"),"listadoAplicacionesConfiguradasParaEstePaso")
  }      
  else if(paso === "errorBorradoAplicacion"){
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display"        
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display: none" 
    document.getElementById("divConfigurarSinDireccion").style = "display: none"   
  }
  else if(paso === "listadoAplicacionesDisponibles"){
    localStorage.removeItem("devicesAction")
    document.getElementById("textoBuscador").value = ""
    
    //Filtro las aplicaciones NO configuradas disponibles para este paso
    module.exports.filtrarAplicaciones()

    if(setSelecteDeviceToConfigure !== "noUpdate"){      
      setSelecteDeviceToConfigure(localStorage.getItem("deviceToConfigure"))         
    }    

    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"  
    document.getElementById("divCalculadoraPotencia").style = "display: none"          
    document.getElementById("divCalculadoraTarifa").style = "display: none"   
    document.getElementById("divConfigurarSinDireccion").style = "display: none" 
    
    if(localStorage.getItem("ongoingStepConfiguration") === "DEVICES"){
      if(document.getElementById("botonAtrasAppsDisponibles") !== null){
        document.getElementById("botonAtrasAppsDisponibles").style = "display: none"    
      }      
      document.getElementById("spanIconVincular").innerHTML = "devices_other"
    }

  }
  else if(paso === "formularioRegistroAplicacion"){
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display: none"  
    document.getElementById("divConfigurarSinDireccion").style = "display: none"  
  }
  else if(paso === "listadoDispositivosDisponibles"){
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display"
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display: none"   
    document.getElementById("divConfigurarSinDireccion").style = "display: none" 
  }
  else if(paso === "divCalculadoraPotencia"){
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("divCalculadoraPotencia").style = "display"    
    document.getElementById("divCalculadoraTarifa").style = "display: none"    
    document.getElementById("divConfigurarSinDireccion").style = "display: none"
  }
  else if(paso === "divCalculadoraTarifa"){
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display"    
    document.getElementById("divConfigurarSinDireccion").style = "display: none"    
  }
  else if(paso === "divConfigurarSinDireccion"){
    localStorage.removeItem("devicesAction")
    document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"    
    document.getElementById("errorBorradoAplicacion").style = "display: none"          
    document.getElementById("listadoAplicacionesDisponibles").style = "display: none"
    document.getElementById("formularioRegistroAplicacion").style = "display: none"
    document.getElementById("listadoDispositivosDisponibles").style = "display: none"
    document.getElementById("divCalculadoraPotencia").style = "display: none"    
    document.getElementById("divCalculadoraTarifa").style = "display: none"    
    document.getElementById("divConfigurarSinDireccion").style = "display"        
  }
  

}

exports.existeSesion = function(){
  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var ongoingInstallationConfiguration = localStorage.getItem("ongoingInstallationConfiguration")

  //if( (lastAuthUser !== null) && (ongoingInstallationConfiguration !== null) ){ //ANTES DE EMPEZAR CON EL ASESORAMIENTO PÚBLICO ESTABA ESTO.
  if( (lastAuthUser !== null) || (ongoingInstallationConfiguration !== null) ){    
    return true
  }
  else{
    try{
      module.exports.mostrarErrorGeneral("info","SESIÓN EXPIRADA","Debes volver a introducir tus credenciales de acceso.")    
    }
    catch(error){ return false }
    
  }
}

exports.gestionarRespuestaPeticionErronea = function(responseStatus){  
      
  responseStatus = parseInt(responseStatus)

  try{
    document.getElementById("iconoRefrescoDashboard").className = document.getElementById("iconoRefrescoDashboard").className.replaceAll(" updating", "")
    document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" loading", "")
  }
  catch(error){}

  if ((responseStatus === 401) || (responseStatus === 403)){      
    module.exports.mostrarErrorGeneral("info","SESIÓN EXPIRADA", "Debes volver a introducir tus credenciales de acceso.")          
  }
  else if(responseStatus === 0){
    console.log("Petición abortada por navegación del usuario")
  }
  else{      
    module.exports.mostrarErrorGeneral("report","ERROR",'Se ha producido un error '+responseStatus+' al procesar la solicitud.')      
  }
  
}

exports.mostrarMensajeInformativo = function(mensajeError, tipoMensaje){
  
  document.getElementById("toastInformativo").innerHTML = mensajeError
  document.getElementById("toastInformativo").className = "toast visible "+tipoMensaje    
  setTimeout(function invisible(){document.getElementById("toastInformativo").className = "toast invisible"}, 5000)

  console.log("Mensaje informativo mostrado")

}

exports.seleccionarOtraInstalacion = function(){
  document.getElementById("divErrorGeneral").className = document.getElementById("divErrorGeneral").className.replaceAll(" hidden", "") + " hidden"
  document.getElementById("divLimitesSuscripcion").className = document.getElementById("divLimitesSuscripcion").className.replaceAll(" hidden", "") + " hidden"
  document.getElementById("divSelectorInstalacion").className = document.getElementById("divSelectorInstalacion").className.replaceAll(" hidden", "")
}

exports.navegarASoporte = function(){
  window.location = "/Support"
}

exports.mostrarErrorGeneral = function(tipoError, cabeceraError, mensajeError){  

  //<div className="message error huge">
  // opciones: success error warning info

  document.getElementById("loaderGeneralAplicacion").className="loader hidden"
  document.getElementById("divErrorGeneral").className="loader"    
  document.getElementById("spanIconErrorGeneral").innerHTML=tipoError
  document.getElementById("h1ErrorGeneral").innerHTML=cabeceraError
  document.getElementById("textoErrorGeneral").innerHTML=mensajeError

  document.getElementById("errorInstallationSelectionButton").onclick = module.exports.seleccionarOtraInstalacion
  document.getElementById("errorReportingButton").onclick = module.exports.navegarASoporte
  document.getElementById("errorExitButton").onclick = module.exports.Logout

  if (localStorage.getItem("installationName") !== null){
    if ( (localStorage.getItem("installationName").includes("INSTALADOR")) || (localStorage.getItem("availableInstallations").split("|").length) === 1 ){
      document.getElementById("errorInstallationSelectionButton").className += " hidden"
    }
    else{
      document.getElementById("errorInstallationSelectionButton").className = document.getElementById("errorInstallationSelectionButton").className.replaceAll(" hidden", "")
    }
  }

  if(cabeceraError === "ERROR"){
    document.getElementById("errorReportingButton").className = document.getElementById("errorReportingButton").className.replaceAll(" hidden", "")
    document.getElementById("errorBackToHome").className = document.getElementById("errorBackToHome").className.replaceAll(" hidden", "")
    document.getElementById("errorExitButton").className = document.getElementById("errorExitButton").className.replaceAll(" hidden", "") + " hidden"    
  }
  else{document.getElementById("errorReportingButton").className += " hidden"}
  
  if(cabeceraError === "SESIÓN EXPIRADA"){
    document.getElementById("divErrorGeneral").className = document.getElementById("divErrorGeneral").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("errorInstallationSelectionButton").className += " hidden"
    document.getElementById("errorBackToHome").className = document.getElementById("errorBackToHome").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("errorExtendSession").className = document.getElementById("errorExtendSession").className.replaceAll(" hidden", "")
    window.location.reload()
  }
  else{
    document.getElementById("errorInstallationSelectionButton").className.replaceAll(" hidden", "")
    document.getElementById("errorBackToHome").className = document.getElementById("errorBackToHome").className.replaceAll(" hidden", "")
  }

}

exports.borrarCuentaUSuario = function(){ 
  module.exports.mostrarMensajeInformativo("Borro cuenta usuario","positive")
  window.location.href="/Logout"
}

exports.mantenerCuentaUSuario = function(){   
  module.exports.mostrarMensajeInformativo("Conservo la cuenta y relanzo el onboarding.","positive")
  window.location.href="/"
}

exports.reiniciarInstalacion = function(){
         
  var nombreInstalacion = ""
  
  try{
    nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML
  }
  catch(error){console.log(error)}

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  console.log("Procedo con el reinicio")
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML='Eliminando '+nombreInstalacion
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var idInstalacion = localStorage.getItem("installationId")
  
  if(idInstalacion === null ){ //Borro desde registro de nueva instalación
    idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  }

  var xhttp = new XMLHttpRequest();
  xhttp.open("DELETE", deleteAccountIDInstallation, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
  var data = JSON.stringify({"IdToken": lastAuthUserIdToken, "idInstalacion": idInstalacion, "reset": "true"});
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          
      document.getElementById("loaderGeneralAplicacion").className="loader hidden"                  
      window.location.href="/Dashboard"      
    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)                   
    }            
  };
  xhttp.send(data); 

}

exports.eliminarInstalacion = function(){
         
  var nombreInstalacion = ""
  
  try{
    nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML
  }
  catch(error){console.log(error)}

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  console.log("Procedo con el borrado")
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML='Eliminando '+nombreInstalacion
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var idInstalacion = localStorage.getItem("installationId")
  
  if(idInstalacion === null ){ //Borro desde registro de nueva instalación
    idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  }

  var xhttp = new XMLHttpRequest();
  xhttp.open("DELETE", deleteAccountIDInstallation, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
  var data = JSON.stringify({"IdToken": lastAuthUserIdToken, "idInstalacion": idInstalacion});
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          
      document.getElementById("loaderGeneralAplicacion").className="loader hidden"            

      localStorage.removeItem("installationId")
      
      if( (localStorage.getItem("ongoingStepConfiguration") !== null) && (localStorage.getItem("ongoingStepConfiguration").includes("INSTALLER")) ){ //Limpio sesión porque es la única cuenta que tendrá
        generalCommonJS.limpiarDatosSesion()
      }     
      
      window.location.href="/"      

    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)                   
    }            
  };
  xhttp.send(data); 

}

exports.realizarBajaDuranteRegistro = function(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
  var lastAuthUserAccessToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".accessToken")        

  console.log("Procedo con el borrado")
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML='Dando de baja tu cuenta'
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var idInstalacion = localStorage.getItem("installationId")
  
  if(idInstalacion === null ){ //Borro desde registro de nueva instalación
    idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  }

  var xhttp = new XMLHttpRequest();
  xhttp.open("DELETE", deleteAccountIDInstallation, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
  var data = JSON.stringify({"IdToken": lastAuthUserIdToken, "idInstalacion": idInstalacion, "AccessToken": lastAuthUserAccessToken});
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          
      document.getElementById("loaderGeneralAplicacion").className="loader hidden"            

      localStorage.removeItem("installationId")
      
      if( (localStorage.getItem("ongoingStepConfiguration") !== null) && (localStorage.getItem("ongoingStepConfiguration").includes("INSTALLER")) ){ //Limpio sesión porque es la única cuenta que tendrá
        generalCommonJS.limpiarDatosSesion()
      }     
      
      window.location.href="/Logout"      

    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)                   
    }            
  };
  xhttp.send(data); 

}

exports.reiniciarMaximoHistorico = function(){
  
  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  console.log("Procedo con el reinicio del máximo histórico")
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML=''
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", postInstallationMaximunConsumptionReset, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
  var data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId")});
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          

      var jsonRespuesta = JSON.parse(this.responseText)

      if(jsonRespuesta.statusCode === "200"){        
        
        try{
          document.getElementById("consumoMaximoHistoricoTotal").innerHTML="0 Wh"            
          module.exports.mostrarMensajeInformativo("Consumo máximo histórico reiniciado correctamente.","positive")
        }
        catch(error){console.log(error)}
      }
      else{
        module.exports.mostrarMensajeInformativo("No se pudo completar la operación, inténtalo de nuevo en unos segundos.","negative")
      }

      document.getElementById("loaderGeneralAplicacion").className="loader hidden"

    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)                   
    }            
  };
  xhttp.send(data); 

}

exports.eliminarCuentaUsuario = function(ReactGA){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")  
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML='Eliminando cuenta de usuario '+generalCommonJS.obtenerEmailUsuario()
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", userAccountFullDeletion, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);  
  var data = JSON.stringify({"idToken": lastAuthUserIdToken});
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          
      document.getElementById("loaderGeneralAplicacion").className="loader hidden"               
      console.log("Usuario cognito eliminado correctamente")                            
      module.exports.mostrarMensajeInformativo("Cuenta de usuario eliminada correctamente.","positive")
      generalCommonJS.limpiarDatosSesion()
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ELIMINACIÓN CUENTA', 'ELIMINACIÓN CUENTA - Correcto', generalCommonJS.obtenerEmailUsuario(), "")
      window.location.href = "/"
      
    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)         
      module.exports.mostrarMensajeInformativo("Se produjo un error al eliminar la cuenta de usuario.","negative")          
    }            
  };
  xhttp.send(data);   

}

exports.eliminarCuentaInstalador = function(ReactGA){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")  
  
  document.getElementById("loaderGeneralAplicacionLabel").innerHTML='Eliminando cuenta de usuario '+generalCommonJS.obtenerEmailUsuario()
  document.getElementById("loaderGeneralAplicacion").className="loader overlay"				
  document.getElementById("divErrorGeneral").className="loader hidden" 

  var xhttp = new XMLHttpRequest();
  xhttp.open("DELETE", deleteAccountIDInstaller, true);        
  xhttp.setRequestHeader('Content-Type', "application/json");
  xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);  
  var data = JSON.stringify({"idToken": lastAuthUserIdToken, "idInstalacion": localStorage.getItem("installationId") });
      
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {          
      document.getElementById("loaderGeneralAplicacion").className="loader hidden"               
      console.log("Usuario cognito eliminado correctamente")                            
      module.exports.mostrarMensajeInformativo("Cuenta de instalador eliminada correctamente.","positive")
      generalCommonJS.limpiarDatosSesion()
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ELIMINACIÓN CUENTA', 'ELIMINACIÓN CUENTA INSTALADOR- Correcto', generalCommonJS.obtenerEmailUsuario(), "")
      window.location.href = "/"
      
    }            
    if (this.readyState === 4 && this.status !== 200) {                        
      module.exports.gestionarRespuestaPeticionErronea(this.status)         
      module.exports.mostrarMensajeInformativo("Se produjo un error al eliminar la cuenta de usuario.","negative")          
    }            
  };
  xhttp.send(data);   

}

exports.mostrarMensajeOperacionAutomaticoGeneral = function(tipoError, cabeceraError, mensajeError, funcionApagado, funcionCancelar){  

  //<div className="message error huge">
  // opciones: success error warning info

  document.getElementById("loaderGeneralAplicacion").className="loader hidden"
  document.getElementById("divIconoErrorGeneral").className = "message error huge"    
  document.getElementById("divErrorGeneral").className="loader"    
  document.getElementById("spanIconErrorGeneral").innerHTML=tipoError
  document.getElementById("h1ErrorGeneral").innerHTML=cabeceraError
  document.getElementById("textoErrorGeneral").innerHTML=mensajeError

  document.getElementById("errorReportingButton").innerHTML = "Apagar"
  document.getElementById("errorExitButton").innerHTML = "Cancelar"
  document.getElementById("errorExitButton").className = document.getElementById("errorExitButton").className.replaceAll("primary", "secondary")

  document.getElementById("errorInstallationSelectionButton").className += " hidden"
  
  document.getElementById("errorReportingButton").onclick = funcionApagado
  document.getElementById("errorExitButton").onclick = funcionCancelar

  
}

exports.mostrarMensajeConfirmacionBorrado = function(tipoError, cabeceraError, mensajeError, funcionBorrado, funcionCancelar){  

  //<div className="message error huge">
  // opciones: success error warning info

  document.getElementById("loaderGeneralAplicacion").className="loader hidden"
  document.getElementById("divIconoErrorGeneral").className = "message error huge"    
  document.getElementById("divErrorGeneral").className="loader"    
  document.getElementById("spanIconErrorGeneral").innerHTML=tipoError
  document.getElementById("h1ErrorGeneral").innerHTML=cabeceraError
  document.getElementById("textoErrorGeneral").innerHTML=mensajeError

  document.getElementById("errorReportingButton").innerHTML = "Borrar"
  document.getElementById("errorExitButton").innerHTML = "Cancelar"
  document.getElementById("errorExitButton").className = document.getElementById("errorExitButton").className.replaceAll("primary", "secondary")

  document.getElementById("errorInstallationSelectionButton").className += " hidden"
  
  document.getElementById("errorReportingButton").onclick = funcionBorrado
  document.getElementById("errorExitButton").onclick = funcionCancelar

  
}

exports.mostrarMensajeConfirmacionAltaInstalacion = function(tipoError, cabeceraError, mensajeError, funcionAlta, funcionCancelar){  

  //<div className="message error huge">
  // opciones: success error warning info

  document.getElementById("loaderGeneralAplicacion").className="loader hidden"  
  document.getElementById("divIconoErrorGeneral").className = "message info huge"    
  document.getElementById("divErrorGeneral").className="loader"    
  document.getElementById("spanIconErrorGeneral").innerHTML=tipoError
  document.getElementById("h1ErrorGeneral").innerHTML=cabeceraError
  document.getElementById("textoErrorGeneral").innerHTML=mensajeError

  document.getElementById("errorReportingButton").innerHTML = "Continuar"
  document.getElementById("errorExitButton").innerHTML = "Cancelar"
  document.getElementById("errorExitButton").className = document.getElementById("errorExitButton").className.replaceAll("primary", "secondary")

  document.getElementById("errorInstallationSelectionButton").className += " hidden"
  
  document.getElementById("errorReportingButton").onclick = funcionAlta
  document.getElementById("errorExitButton").onclick = funcionCancelar

  
}

exports.cerrarMensajeBorrado = function(){
  document.getElementById("divErrorGeneral").className=" hidden"
}

exports.inicializarCampoSelector = function(campo){
  document.getElementById(campo).value = ""    
  document.getElementById(campo+"FieldsetSinConfigurar").style = "display"
  document.getElementById(campo+"FieldsetSeleccionado").style = "display: none"

  if(localStorage.getItem("ongoingStepConfiguration").includes("GENERAL_INFO")){
    if(document.getElementById("acometidaPrincipal1").value !== "" ){
      document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className + " hidden"
    }
  }

}

exports.comprobarEstadoRegistroMensajeria = function(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
  var ongoingInstallationConfigurationID = ""

  if(localStorage.getItem("ongoingInstallationConfiguration") !== null){
    ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")        
  }
  else{
    ongoingInstallationConfigurationID = localStorage.getItem("installationId")        
  }

  //Petición de datos para el paso actual
  var jsonPeticion = {
    "accountID": localStorage.getItem("accountID"),
    "installationID": ongoingInstallationConfigurationID    
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", getHelias3pCredentials, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)
        if(jsonRespuesta.statusCode === "403"){                   
          module.exports.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          

          var objRespuestaCuentasExistentes = jsonRespuesta.body
          
          if(objRespuestaCuentasExistentes.length > 0){ //Ya tengo aplicaciones registradas
            
            for (var i = 0; i < objRespuestaCuentasExistentes.length; i++) {

              if(objRespuestaCuentasExistentes[i].Aplicacion === "TELEGRAM"){
                
                localStorage.setItem("telegramAccount", objRespuestaCuentasExistentes[i].Usuario)                
                
              }              

            }
          }
          
          //Si no lo tengo en la agenda dejo el formulario como está

          if(document.getElementById("botonNuevaRegla") !== null){
            document.getElementById("botonNuevaRegla").disabled = false
          }          

          console.log("Información cargada correctamente")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {                          
        module.exports.gestionarRespuestaPeticionErronea(this.status)       
      }
    }
    xhttp.send(data);      
}

exports.Logout = function(){        
    document.getElementById("divErrorGeneral").className="loader hidden"
    if(localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser") !== null){
      window.location.href = '/Logout'
    }
    else{
      window.location.href = '/'
    }
    
}

exports.antiBackOnboarding = function(){

  //No hay un lastAccess hasta que se hace el acceso inicial, eso significa que si no está es que estoy todavía con la primera configuración

  var antiback = false

  if( (localStorage.getItem("installationConfigurationMode") === null) && (localStorage.getItem("lastAccess") !== null ) ){ //USUARIO
    //Si he llegado a la página a través del botón back o forward del navegador redirijo al Dashboard
    antiback = true

    if ( (localStorage.getItem("installationName") !== null) && (localStorage.getItem("installationName").includes("INSTALADOR")) ){
      window.location.href = "/InstallerDashboard"
    }
    else{

      try{
        var jsonStripeData = JSON.parse(localStorage.getItem("stripeData"))

        if ( (window.location.href.includes("UserInitialConfig/GeneralInfo") && (Object.keys(jsonStripeData).length === 0) ) ){ //Si acabo de realizar un pago repito el acceso para refrescar datos de stripe        
          window.location.href = "/"
        }
        else{
          window.location.href = "/Dashboard"
        }
      }
      catch(error){
        window.location.href = "/Dashboard"
      }

    }    
  }

  return antiback
  
}

exports.mostrarPotenciaEnTabla = function(configPotencia){

  var elementosPotencia = configPotencia.split("#")
  var elementosTramoPotencia = ""  

  document.getElementById("tablaPotenciaContratada").className = document.getElementById("tablaPotenciaContratada").className.replaceAll(" hidden", "")

  for(var x=0; x < 6; x++){

    if( (elementosPotencia[x] !== null) && (elementosPotencia[x] !== undefined) ){
      elementosTramoPotencia = elementosPotencia[x].split("|")
      document.getElementById("trPotenciaContratadaP"+(x+1)).className = document.getElementById("trPotenciaContratadaP"+(x+1)).className.replaceAll(" hidden", "")
      document.getElementById("valorPotenciaContratadaP"+(x+1)).innerHTML = elementosTramoPotencia[0] + " kW"
      document.getElementById("tarifaPotenciaContratadaP"+(x+1)).innerHTML = elementosTramoPotencia[1] + " €/kW"
    }
    else{
      document.getElementById("trPotenciaContratadaP"+(x+1)).className = document.getElementById("trPotenciaContratadaP"+(x+1)).className + " hidden"
      document.getElementById("valorPotenciaContratadaP"+(x+1)).innerHTML = ""
      document.getElementById("tarifaPotenciaContratadaP"+(x+1)).innerHTML = ""
    }    
    
  }

  if(elementosPotencia.length === 1){
    document.getElementById("spanPotenciaP1").innerHTML ="P1 : Punta | Llano | Valle"
  }

  if(elementosPotencia.length === 2){
    document.getElementById("spanPotenciaP1").innerHTML ="P1 : Punta | Llano"
    document.getElementById("spanPotenciaP2").innerHTML ="P2 : Valle"
  }  

  if(elementosPotencia.length === 6){
    document.getElementById("spanPotenciaP1").innerHTML ="P1 :"
    document.getElementById("spanPotenciaP2").innerHTML ="P2 :"
    document.getElementById("spanPotenciaP3").innerHTML ="P3 :"
  } 

}

exports.mostrarTarifasEnTabla = function(configTarifas){

  var elementosTarifa = configTarifas.split("#")  

  document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")

  for(var x=0; x < 6; x++){

    if( (elementosTarifa[x] !== null) && (elementosTarifa[x] !== undefined) ){      
      document.getElementById("trTarifaEnergiaP"+(x+1)).className = document.getElementById("trTarifaEnergiaP"+(x+1)).className.replaceAll(" hidden", "")      
      document.getElementById("tarifaEnergiaP"+(x+1)).innerHTML = elementosTarifa[x] + " €/kWh"
    }
    else{
      document.getElementById("trTarifaEnergiaP"+(x+1)).className = document.getElementById("trTarifaEnergiaP"+(x+1)).className + " hidden"      
      document.getElementById("tarifaEnergiaP"+(x+1)).innerHTML = ""
    }
    
  }

  if(elementosTarifa.length === 1){
    document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta | Llano | Valle"          
  }  
  else if(elementosTarifa.length === 2){
    document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta | Llano"
    document.getElementById("spanTarifaP2").innerHTML ="P2 : Valle"
  }  
  else if(elementosTarifa.length === 3){
    document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta"
    document.getElementById("spanTarifaP2").innerHTML ="P2 : Llano"
    document.getElementById("spanTarifaP3").innerHTML ="P3 : Valle"
  }  
  else if( (elementosTarifa.length === 4) || (elementosTarifa.length === 5) || (elementosTarifa.length === 6) ){
    document.getElementById("spanTarifaP1").innerHTML ="P1 :"
    document.getElementById("spanTarifaP2").innerHTML ="P2 :"
    document.getElementById("spanTarifaP3").innerHTML ="P3 :"
    document.getElementById("spanTarifaP4").innerHTML ="P4 :"
    document.getElementById("spanTarifaP5").innerHTML ="P5 :"
    document.getElementById("spanTarifaP6").innerHTML ="P6 :"
  }  
  
}

exports.actualizarFormularioTarifasCombo = function(){
    
  var valorSeleccionadoCombo = document.getElementById("selectTarifa").value

  if( (valorSeleccionadoCombo === "OCTOPUS-FLEXI") || (valorSeleccionadoCombo === "LUCERA-VARIABLE") ){
    document.getElementById("formularioTarifasFijas").className = document.getElementById("formularioTarifasFijas").className.replaceAll(" hidden", "") + " hidden"
  }
  else{ //FIJA      
    document.getElementById("formularioTarifasFijas").className = document.getElementById("formularioTarifasFijas").className.replaceAll(" hidden", "")
  }

}

exports.añadirPPotencia = function(){

  var listadoTrsPs = document.getElementById("listadoPsPotencia").querySelectorAll("tr")
  var filasVisibles = 0

  for(var x=0; x < listadoTrsPs.length; x++){        

    filasVisibles++

    if(document.getElementById(listadoTrsPs[x].id).className.includes(" hidden")){
      document.getElementById(listadoTrsPs[x].id).className = document.getElementById(listadoTrsPs[x].id).className.replaceAll(" hidden", "")

      if(x === listadoTrsPs.length-1){
        document.getElementById("botonAñadirPPotencia").className = document.getElementById("botonAñadirPPotencia").className.replaceAll(" hidden", "") + " hidden"
      }

      break
    }
    
  }    

  if(filasVisibles === 1){
    document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano | Valle"
  }
  else if(filasVisibles === 2){
    document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano"
    document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 : Valle"
  }
  else if(filasVisibles === 3){
    document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta"
    document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 : Llano"
  }
  else if(filasVisibles === 4){
    document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 :"
    document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 :"
    document.getElementById("spanCalculadoraPotenciaP3").innerHTML ="P3 :"
  }

}

exports.añadirPTarifa = function(){

  var listadoTrsPs = document.getElementById("listadoPs").querySelectorAll("tr")
  var filasVisibles = 0    

  for(var x=0; x < listadoTrsPs.length; x++){    
    
    filasVisibles++

    if(document.getElementById(listadoTrsPs[x].id).className.includes(" hidden")){
      document.getElementById(listadoTrsPs[x].id).className = document.getElementById(listadoTrsPs[x].id).className.replaceAll(" hidden", "")

      if(x > 0){
        document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta"      
      }

      if(x === listadoTrsPs.length-1){
        document.getElementById("botonAñadirP").className = document.getElementById("botonAñadirP").className.replaceAll(" hidden", "") + " hidden"
      }

      break
    }
    
  }    

  if(filasVisibles === 1){
    document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano | Valle"
    
    if(document.getElementById("potenciaContratada").value.split("#").length === 6){
      document.getElementById("spanTarifasP1").innerHTML ="P1, P2, P3, P4, P5, P6 :"         
    }

  }
  else if(filasVisibles === 2){
    document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano"
    document.getElementById("spanTarifasP2").innerHTML ="P2 : Valle"

    if(document.getElementById("potenciaContratada").value.split("#").length === 6){
      document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
      document.getElementById("spanTarifasP2").innerHTML ="P2 :"                    
    }

  }
  else if(filasVisibles === 3){
    document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta"
    document.getElementById("spanTarifasP2").innerHTML ="P2 : Llano"
    document.getElementById("spanTarifasP3").innerHTML ="P3 : Valle"

    if(document.getElementById("potenciaContratada").value.split("#").length === 6){
      document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
      document.getElementById("spanTarifasP2").innerHTML ="P2 :"              
      document.getElementById("spanTarifasP3").innerHTML ="P3 :"         
    }

  }    
  else if( (filasVisibles === 4) || (filasVisibles === 5) || (filasVisibles === 6) ){
    document.getElementById("spanTarifasP1").innerHTML ="P1 :"
    document.getElementById("spanTarifasP2").innerHTML ="P2 :"
    document.getElementById("spanTarifasP3").innerHTML ="P3 :"
    document.getElementById("spanTarifasP4").innerHTML ="P4 :"
    document.getElementById("spanTarifasP5").innerHTML ="P5 :"
    document.getElementById("spanTarifasP6").innerHTML ="P6 :"
  }

}